<template>
  <div
    class="container"
    :class="{
      'guest-readonly': isGuestMode,
      'home-route': $route.path === '/home',
      'settings-route': $route.name === 'ImpostazioniApp',
      'dashboard-route': ['AreaPersonale', 'AreaGestionale'].includes(
        $route.name
      ),
      'converter-route': [
        'ConvProspettiPaghe',
        'ConvModelliF24',
        'ConvBilancioAnalitico',
      ].includes($route.name),
    }"
    @click.capture="blockGuestUiAction"
    @submit.capture="blockGuestUiAction"
  >
    <!-- Barra di navigazione -->
    <nav class="navbar">
      <div
        class="navbar-title"
        @mouseover="showDropdown = true"
        @mouseleave="showDropdown = false"
        @click="goHome"
      >
        <div class="logolink">
          <img :src="logoUrl" alt="Logo MyStudio" class="logo" />
        </div>
        <span class="navbar-title-link">MyStudio</span>
        <i
          class="fa-solid fa-chevron-down navbar-title-chevron"
          aria-hidden="true"
        ></i>

        <!-- Dropdown menu -->
        <div v-if="showDropdown" class="dropdown-menu-home" @click.stop>
          <section class="home-launcher-section">
            <div class="home-launcher-heading">
              <span>Strumenti</span>
              <span
                class="home-launcher-heading-line"
                aria-hidden="true"
              ></span>
            </div>

            <div class="home-launcher-list">
              <router-link to="/home/prospetti-paghe" class="dropdown-item-new">
                <span class="home-launcher-icon">
                  <ProductIcon
                    class="home-launcher-icon-emphasis"
                    product="prospetti"
                  />
                </span>
                <span class="home-launcher-copy">
                  <strong>Prospetti Paghe</strong>
                  <small>Convertitore</small>
                </span>
                <i
                  class="fa-solid fa-chevron-right home-launcher-chevron"
                  aria-hidden="true"
                ></i>
              </router-link>

              <router-link to="/home/modelli-f24" class="dropdown-item-new">
                <span class="home-launcher-icon">
                  <ProductIcon
                    class="home-launcher-icon-emphasis"
                    product="f24"
                  />
                </span>
                <span class="home-launcher-copy">
                  <strong>Modelli F24</strong>
                  <small>Convertitore</small>
                </span>
                <i
                  class="fa-solid fa-chevron-right home-launcher-chevron"
                  aria-hidden="true"
                ></i>
              </router-link>

              <router-link
                to="/home/bilancio-analitico"
                class="dropdown-item-new"
              >
                <span class="home-launcher-icon">
                  <ProductIcon product="bilancio" />
                </span>
                <span class="home-launcher-copy">
                  <strong>Bilancio Analitico</strong>
                  <small>Convertitore</small>
                </span>
                <i
                  class="fa-solid fa-chevron-right home-launcher-chevron"
                  aria-hidden="true"
                ></i>
              </router-link>
            </div>
          </section>

          <section class="home-launcher-section home-launcher-libraries">
            <div class="home-launcher-heading">
              <span>Librerie</span>
              <span
                class="home-launcher-heading-line"
                aria-hidden="true"
              ></span>
            </div>

            <div class="home-launcher-list">
              <router-link
                to="/home/libreria-codici-conto"
                class="dropdown-item-new"
              >
                <span class="home-launcher-icon">
                  <LibraryIcon
                    class="home-launcher-library-icon"
                    library="conti"
                  />
                </span>
                <span class="home-launcher-copy">
                  <strong>Codici Conto</strong>
                </span>
                <i
                  class="fa-solid fa-chevron-right home-launcher-chevron"
                  aria-hidden="true"
                ></i>
              </router-link>

              <router-link
                to="/home/libreria-codici-tributo"
                class="dropdown-item-new"
              >
                <span class="home-launcher-icon">
                  <LibraryIcon
                    class="home-launcher-library-icon"
                    library="tributi"
                  />
                </span>
                <span class="home-launcher-copy">
                  <strong>Codici Tributo</strong>
                </span>
                <i
                  class="fa-solid fa-chevron-right home-launcher-chevron"
                  aria-hidden="true"
                ></i>
              </router-link>

              <router-link
                to="/home/libreria-bilanci-analitici"
                class="dropdown-item-new"
              >
                <span class="home-launcher-icon">
                  <LibraryIcon
                    class="home-launcher-library-icon"
                    library="bilanci"
                  />
                </span>
                <span class="home-launcher-copy">
                  <strong>Bilanci Analitici</strong>
                </span>
                <i
                  class="fa-solid fa-chevron-right home-launcher-chevron"
                  aria-hidden="true"
                ></i>
              </router-link>
            </div>
          </section>

          <div class="home-launcher-store">
            <span
              v-if="isGuestMode"
              class="dropdown-item-new guest-disabled-link"
              title="Registrati per visualizzare la pagina"
            >
              <span class="home-launcher-icon">
                <i
                  class="fa-solid fa-cart-shopping home-launcher-store-fa"
                  aria-hidden="true"
                ></i>
              </span>
              <span class="home-launcher-copy"><strong>Store</strong></span>
              <i
                class="fa-solid fa-chevron-right home-launcher-chevron"
                aria-hidden="true"
              ></i>
            </span>
            <router-link v-else to="/home/store" class="dropdown-item-new">
              <span class="home-launcher-icon">
                <i
                  class="fa-solid fa-cart-shopping home-launcher-store-fa"
                  aria-hidden="true"
                ></i>
              </span>
              <span class="home-launcher-copy"><strong>Store</strong></span>
              <i
                class="fa-solid fa-chevron-right home-launcher-chevron"
                aria-hidden="true"
              ></i>
            </router-link>
          </div>
        </div>
      </div>
      <div class="navbar-menu">
        <div class="nav-item">
          <span
            v-if="isGuestMode"
            class="icons guest-nav-disabled"
            title="Registrati per visualizzare la pagina"
          >
            <i class="fa-solid fa-circle-question icon"></i>
          </span>
          <router-link
            v-else
            to="/home/help"
            class="icons"
            title="Help MyStudio"
          >
            <i class="fa-solid fa-circle-question icon"></i>
          </router-link>
        </div>
        <div class="nav-item">
          <span
            v-if="isGuestMode"
            class="icons guest-nav-disabled"
            title="Registrati per visualizzare la pagina"
          >
            <i class="fa-solid fa-cart-shopping shopicon"></i>
          </span>
          <router-link v-else to="/home/store" class="icons" title="Store">
            <i class="fa-solid fa-cart-shopping shopicon"></i>
          </router-link>
        </div>
        <div class="nav-item" @mouseleave="showToolsMenu = false">
          <span
            title="Strumenti MyStudio"
            class="icons"
            :class="{ selected: showToolsMenu }"
            @mouseover="
              showToolsMenu = true;
              showAccountMenu = false;
            "
          >
            <i class="material-icons">apps</i>
          </span>

          <div
            v-if="showToolsMenu"
            class="google-apps-menu"
            @mouseover="showToolsMenu = true"
            @mouseleave="showToolsMenu = false"
          >
            <div class="apps-grid">
              <div class="apps-section-label">Convertitori</div>
              <router-link
                to="/home/prospetti-paghe"
                class="app-item app-item-paghe"
              >
                <div class="app-icon green">
                  <ProductIcon product="prospetti" />
                </div>
                <div class="app-label">
                  Prospetti<br />
                  Paghe
                </div>
              </router-link>

              <router-link to="/home/modelli-f24" class="app-item app-item-f24">
                <div class="app-icon blue">
                  <ProductIcon product="f24" />
                </div>
                <div class="app-label">
                  Modelli <br />
                  F24
                </div>
              </router-link>

              <router-link
                to="/home/bilancio-analitico"
                class="app-item app-item-bilancio"
              >
                <div class="app-icon gray">
                  <ProductIcon product="bilancio" />
                </div>
                <div class="app-label">Bilancio Analitico</div>
              </router-link>

              <div class="apps-section-label">Librerie</div>
              <router-link
                to="/home/libreria-codici-conto"
                class="app-item app-item-paghe"
              >
                <div class="app-icon green">
                  <LibraryIcon library="conti" />
                </div>
                <div class="app-label">
                  Codici<br />
                  Conto
                </div>
              </router-link>

              <router-link
                to="/home/libreria-codici-tributo"
                class="app-item app-item-f24"
              >
                <div class="app-icon blue">
                  <LibraryIcon library="tributi" />
                </div>
                <div class="app-label">Codici<br />Tributo</div>
              </router-link>

              <router-link
                to="/home/libreria-bilanci-analitici"
                class="app-item app-item-bilancio"
              >
                <div class="app-icon gray">
                  <LibraryIcon library="bilanci" />
                </div>
                <div class="app-label">Bilanci Analitici</div>
              </router-link>
            </div>
          </div>
        </div>
        <div class="nav-item" ref="accountMenuRef">
          <span
            title="Profilo"
            class="icons"
            :class="{
              selected: showAccountMenu,
              'guest-profile-icon': isGuestMode,
            }"
            @click="toggleAccountMenu"
          >
            <i class="fa-solid fa-user icon"></i>
          </span>
          <div
            v-if="showAccountMenu"
            class="dropdown-menu-account"
            :class="{
              'account-menu-authenticated': !isGuestMode,
              'account-menu-guest': isGuestMode,
            }"
          >
            <template v-if="isGuestMode">
              <div class="infoaccount guest-account-info">
                <div class="account-eyebrow">Accesso</div>
                <div class="account-title-row">
                  <span id="nomeStudio">Modalità ospite</span>
                </div>
                <div class="guest-account-note">
                  Puoi consultare MyStudio in sola lettura. Registrati o accedi
                  per usare convertitori, librerie e funzioni operative.
                </div>
              </div>
              <button
                type="button"
                class="account-action guest-account-action guest-menu-disabled guest-action-personal"
                disabled
              >
                <i class="fa-solid fa-user" aria-hidden="true"></i>
                <span>Area Personale</span>
                <i class="fa-solid fa-chevron-right account-action-chevron"></i>
              </button>
              <button
                type="button"
                class="account-action guest-account-action guest-menu-disabled guest-action-studio"
                disabled
              >
                <i class="fa-solid fa-users" aria-hidden="true"></i>
                <span>Il Mio Studio</span>
                <i class="fa-solid fa-chevron-right account-action-chevron"></i>
              </button>
              <button
                type="button"
                class="account-action guest-account-action guest-menu-disabled guest-action-settings"
                disabled
              >
                <i class="fa-solid fa-gear" aria-hidden="true"></i>
                <span>Impostazioni</span>
                <i class="fa-solid fa-chevron-right account-action-chevron"></i>
              </button>
              <button
                type="button"
                class="account-action guest-account-action guest-register-button guest-action-register"
                title="Crea un account MyStudio"
                @click="startGuestRegistration"
              >
                <i class="fa-solid fa-user-plus" aria-hidden="true"></i>
                <span>Registrati</span>
                <i class="fa-solid fa-chevron-right account-action-chevron"></i>
              </button>
              <button
                type="button"
                class="account-action guest-account-action guest-action guest-exit-button"
                title="Esci dalla modalita ospite"
                @click="exitGuestMode"
              >
                <i class="fa-solid fa-right-from-bracket"></i>
                <span>Esci</span>
              </button>
            </template>
            <div v-else class="infoaccount">
              <div class="account-eyebrow">MyStudio</div>
              <div class="account-profile-row">
                <div class="account-studio-avatar" aria-hidden="true">
                  <i class="fa-solid fa-building"></i>
                </div>
                <div class="account-title-stack">
                  <span id="nomeStudio">
                    {{ studioUtente }}
                  </span>
                  <div class="user-label account-user-row">
                    <i class="fa-solid fa-user usericon"></i>
                    <span id="userEmail" class="account-user-text">
                      {{ accountDisplayName }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="account-meta">
                <router-link
                  to="/home/store"
                  class="account-chip account-chip-plan"
                  :class="planBadgeClass"
                  title="Apri lo Store per gestire il piano"
                  @click.native="showAccountMenu = false"
                >
                  <i class="fa-solid fa-graduation-cap"></i>
                  <span class="account-chip-copy">
                    <span class="account-chip-label">Piano</span>
                    <span class="account-plan-value">
                      {{ currentPlanLabel }}
                    </span>
                  </span>
                </router-link>
                <router-link
                  to="/home/store"
                  class="account-chip account-chip-coin account-chip-coin-link"
                  title="Apri lo Store per ricaricare i Coin"
                  @click.native="showAccountMenu = false"
                >
                  <i class="fa-solid fa-coins" aria-hidden="true"></i>
                  <span class="account-chip-copy">
                    <span class="account-chip-label">Coin</span>
                    <span id="creditiAttuali">
                      {{ creditiRimanenti }}
                    </span>
                  </span>
                </router-link>
              </div>
            </div>
            <router-link
              v-if="!isGuestMode"
              to="/home/area-personale"
              class="account-action-link"
            >
              <button
                id="area-personale"
                class="account-action account-action-personal"
              >
                <i class="fa-solid fa-user"></i>
                <span>Area Personale</span>
                <i class="fa-solid fa-chevron-right account-action-chevron"></i>
              </button>
            </router-link>
            <router-link
              :to="{ name: 'AreaGestionale', query: { tab: 'studio' } }"
              v-if="!isGuestMode"
              class="account-action-link"
            >
              <button
                id="area-gestionale"
                class="account-action account-action-studio"
              >
                <i class="fa-solid fa-users"></i>
                <span>Il Mio Studio</span>
                <i class="fa-solid fa-chevron-right account-action-chevron"></i>
              </button>
            </router-link>
            <router-link
              to="/home/area-amministratore"
              v-if="isAdminMyStudio"
              class="account-action-link"
            >
              <button
                id="area-admin"
                class="account-action account-action-admin"
              >
                <i class="fa-solid fa-crown"></i>
                <span>Gestione MyStudio</span>
                <i class="fa-solid fa-chevron-right account-action-chevron"></i>
              </button>
            </router-link>
            <router-link
              v-if="!isGuestMode"
              to="/home/impostazioni"
              class="account-action-link"
            >
              <button
                id="settings"
                class="account-action account-action-settings"
              >
                <i
                  class="fa-solid fa-gear settingsicon"
                  title="Impostazioni"
                ></i>
                <span>Impostazioni</span>
                <i class="fa-solid fa-chevron-right account-action-chevron"></i>
              </button>
            </router-link>
            <button
              v-if="!isGuestMode"
              id="user-menu"
              class="account-action account-action-logout"
              @click="openLogoutModal"
            >
              <i class="fa-solid fa-right-from-bracket"></i>
              <span>Esci</span>
            </button>
          </div>
        </div>
      </div>
    </nav>
    <AppBreadcrumb v-if="$route.name !== 'HomePage'" />
    <NewsSection />
    <!-- Sezione specifica per /home -->
    <div class="home" v-if="$route.path === '/home'">
      <div class="home-container">
        <section class="home-hero-shell" aria-labelledby="home-title">
          <div class="home-hero-copy">
            <span class="home-eyebrow">Home</span>
            <h1 id="home-title">Benvenuto in MyStudio</h1>
            <p>
              Gli strumenti per semplificare il lavoro del tuo studio,<br />
              in un unico ambiente.
            </p>
          </div>

          <div class="home-hero-visual" aria-hidden="true">
            <img class="home-hero-art" :src="homeHeroImage" alt="" />
          </div>

          <div class="home-shortcuts">
            <template v-if="isGuestMode">
              <button
                type="button"
                class="home-shortcut is-disabled"
                title="Disponibile solo per gli utenti registrati"
                aria-label="Anagrafica Clienti, non disponibile in modalità ospite"
                disabled
              >
                <i class="fa-solid fa-user-group" aria-hidden="true"></i>
                <span>Anagrafica Clienti</span>
              </button>
              <button
                type="button"
                class="home-shortcut is-disabled"
                title="Disponibile solo per gli utenti registrati"
                aria-label="Archivio file convertiti, non disponibile in modalità ospite"
                disabled
              >
                <i class="fa-solid fa-cloud-arrow-down" aria-hidden="true"></i>
                <span>Archivio file convertiti</span>
              </button>
            </template>
            <template v-else>
              <router-link
                :to="{ name: 'AreaGestionale', query: { tab: 'clienti' } }"
                class="home-shortcut"
                title="Consulta l'anagrafica"
              >
                <i class="fa-solid fa-user-group" aria-hidden="true"></i>
                <span>Anagrafica Clienti</span>
                <i class="fa-solid fa-chevron-right" aria-hidden="true"></i>
              </router-link>
              <router-link
                :to="{ name: 'AreaGestionale', query: { tab: 'archivio' } }"
                class="home-shortcut"
                title="Consulta l'archivio file"
              >
                <i class="fa-solid fa-cloud-arrow-down" aria-hidden="true"></i>
                <span>Archivio file convertiti</span>
                <i class="fa-solid fa-chevron-right" aria-hidden="true"></i>
              </router-link>
            </template>
          </div>
        </section>

        <section class="tools-grid" aria-label="Strumenti MyStudio">
          <article
            v-for="section in homeSections"
            :key="section.title"
            class="feature-section"
            :style="{
              '--section-accent': section.accent,
              '--section-accent-strong': section.accentStrong,
              '--section-accent-soft': section.accentSoft,
              '--section-border': section.border,
            }"
          >
            <div class="feature-section-top">
              <div class="feature-heading">
                <div class="feature-icon">
                  <ProductIcon :product="section.product" />
                </div>
                <h2>{{ section.title }}</h2>
              </div>
            </div>

            <img class="feature-illustration" :src="section.image" alt="" />

            <p class="feature-description">{{ section.description }}</p>

            <div class="feature-actions">
              <router-link
                v-for="action in section.actions"
                :key="action.to"
                :to="action.to"
                class="feature-action"
                :class="action.variant"
              >
                <span
                  v-if="action.product"
                  class="feature-action-product-icon"
                  aria-hidden="true"
                >
                  <ProductIcon :product="action.product" />
                </span>
                <span
                  v-else-if="action.library"
                  class="feature-action-library-icon"
                  aria-hidden="true"
                >
                  <LibraryIcon :library="action.library" />
                </span>
                <i v-else :class="action.icon" aria-hidden="true"></i>
                <span class="feature-action-copy">
                  <strong>{{ action.label }}</strong>
                  <small>{{ action.helper }}</small>
                </span>
              </router-link>
            </div>
          </article>
        </section>

        <router-link
          v-if="!isGuestMode"
          to="/home/help"
          class="home-help-strip"
        >
          <span class="home-help-icon" aria-hidden="true">
            <i class="fa-solid fa-circle-question"></i>
          </span>
          <strong>Come usare MyStudio</strong>
          <i class="fa-solid fa-chevron-right home-help-chevron"></i>
        </router-link>
      </div>
      <p v-if="isGuestMode" class="home-footer-action">
        <button
          type="button"
          class="guest-action guest-home-exit-button"
          @click="exitGuestMode"
        >
          <i class="fa-solid fa-right-from-bracket"></i>
          <span>Esci dalla modalità ospite</span>
        </button>
      </p>
      <button
        class="darkmode-btn"
        @click="toggleDarkMode"
        :aria-label="isDarkMode ? 'Modalità chiara' : 'Modalità scura'"
        :title="
          isDarkMode
            ? 'Passa alla modalità chiara'
            : 'Passa alla modalità scura'
        "
      >
        <i :class="isDarkMode ? 'fa-solid fa-sun' : 'fa-solid fa-moon'"></i>
      </button>
    </div>
    <router-view ref="activeChildView" />
    <div></div>
    <transition name="logout-modal">
      <div
        v-if="showModal"
        class="modal-overlay logout-modal-overlay"
        @click.self="closeLogoutModal"
      >
        <section
          ref="logoutDialog"
          class="modal-content logout-confirmation"
          role="alertdialog"
          aria-modal="true"
          aria-labelledby="logout-title"
          aria-describedby="logout-desc"
          :aria-busy="isLoggingOut ? 'true' : 'false'"
          tabindex="-1"
        >
          <header class="logout-modal-header">
            <span class="logout-brand">MyStudio</span>
            <button
              type="button"
              class="logout-close-button"
              aria-label="Chiudi la finestra di uscita"
              :disabled="isLoggingOut"
              @click="closeLogoutModal"
            >
              <i class="fa-solid fa-xmark" aria-hidden="true"></i>
            </button>
          </header>

          <div class="logout-modal-intro">
            <span class="logout-main-icon" aria-hidden="true">
              <i class="fa-solid fa-right-from-bracket"></i>
            </span>
            <h3 id="logout-title">Stai uscendo dall’app</h3>
            <p id="logout-desc">
              Prima di uscire, verifica di aver completato le operazioni in
              corso.
            </p>
          </div>

          <div class="logout-summary" aria-label="Riepilogo della sessione">
            <div class="logout-summary-row">
              <span class="logout-summary-icon" aria-hidden="true">
                <i class="fa-solid fa-building"></i>
              </span>
              <span class="logout-summary-copy">
                <span class="logout-summary-label">Studio attivo:</span>
                <strong>{{ studioUtente || "Il tuo studio" }}</strong>
              </span>
            </div>
            <div class="logout-summary-row">
              <span class="logout-summary-icon" aria-hidden="true">
                <i class="fa-solid fa-user"></i>
              </span>
              <span class="logout-summary-copy">
                <span class="logout-summary-label">Utente:</span>
                <strong>{{ accountDisplayName || "Utente MyStudio" }}</strong>
              </span>
            </div>
          </div>

          <div class="logout-modal-actions">
            <button
              type="button"
              class="logout-button logout-button-secondary"
              :disabled="isLoggingOut"
              @click="closeLogoutModal"
            >
              Annulla
            </button>
            <button
              type="button"
              class="logout-button logout-button-danger"
              :disabled="isLoggingOut"
              @click="confirmLogout"
            >
              <i
                :class="
                  isLoggingOut
                    ? 'fa-solid fa-spinner fa-spin'
                    : 'fa-solid fa-right-from-bracket'
                "
                aria-hidden="true"
              ></i>
              <span>{{ isLoggingOut ? "Uscita…" : "Esci" }}</span>
            </button>
          </div>
        </section>
      </div>
    </transition>
    <footer>MyStudio Copyright (©) 2025</footer>
  </div>
</template>

<script>
import axios from "axios";
import { API_BASE_URL } from "@/config.js";
import { theme } from "@/store/theme.js";
import NewsSection from "@/components/NewsSection.vue";
import AppBreadcrumb from "@/components/AppBreadcrumb.vue";
import ProductIcon from "@/components/ProductIcon.vue";
import LibraryIcon from "@/components/LibraryIcon.vue";
import { signOutFromClerk } from "@/auth/clerk.js";
import { clearGuestSession, isGuestMode } from "@/utils/guestMode.js";

export default {
  name: "HomePage",
  components: {
    AppBreadcrumb,
    NewsSection,
    ProductIcon,
    LibraryIcon,
  },
  data() {
    return {
      isDarkMode: theme.darkMode,
      userEmail: "", // Inizialmente vuoto, verrà impostato successivamente
      firstName: "", // Nuovo: nome
      lastName: "", // Nuovo: cognome
      studioUtente: "",
      logoUrl: "/Pagina%20Welcome/logo.png",
      selectedFile: null,
      showModal: false,
      isLoggingOut: false,
      excelPath: null,
      calculating: false, // Variabile per controllare la visibilità del messaggio di calcolo in corso
      showAccountMenu: false, // Variabile per mostrare/nascondere il menu piano conti
      showToolsMenu: false,
      showDropdown: false, // Per mostrare/nascondere il menu a tendina
      errorMessagePDF: "",
      creditiRimanenti: 0,
      currentPlan: null,
      isTSActive: false,
      isDAactive: false,
      isDLactive: false,
      isZActive: false,
      homeHeroImage: "/Pagina Home/sfondo benvenuto ghiaccio.png",
      homeSections: [
        {
          title: "Prospetti Paghe",
          product: "prospetti",
          image: "/Pagina Home/Prospetti Paghe nitida.png",
          description:
            "Elabora e importa i tuoi Prospetti Paghe nel tuo gestionale. Automatizza il Piano dei Conti per le conversioni future.",
          accent: "#16885f",
          accentStrong: "#076247",
          accentSoft: "rgba(22, 136, 95, 0.13)",
          border: "rgba(22, 136, 95, 0.22)",
          actions: [
            {
              label: "Convertitore",
              helper: "Prospetti Paghe",
              product: "prospetti",
              to: "/home/prospetti-paghe",
              variant: "is-primary",
            },
            {
              label: "Libreria",
              helper: "Codici Conto",
              library: "conti",
              to: "/home/libreria-codici-conto",
              variant: "is-secondary",
            },
          ],
        },
        {
          title: "Modelli F24",
          product: "f24",
          image: "/Pagina Home/F24.png",
          description:
            "Velocizza la registrazione nel tuo gestionale dei Modelli F24 scaricati direttamente dal cassetto fiscale.",
          accent: "#168bd2",
          accentStrong: "#075994",
          accentSoft: "rgba(22, 139, 210, 0.12)",
          border: "rgba(22, 139, 210, 0.22)",
          actions: [
            {
              label: "Convertitore",
              helper: "Modelli F24",
              product: "f24",
              to: "/home/modelli-f24",
              variant: "is-primary",
            },
            {
              label: "Libreria",
              helper: "Codici Tributo",
              library: "tributi",
              to: "/home/libreria-codici-tributo",
              variant: "is-secondary",
            },
          ],
        },
        {
          title: "Bilanci Analitici",
          product: "bilancio",
          image: "/Pagina Home/Bilancio Analitico.png",
          description:
            "Importa nel tuo gestionale i bilanci analitici dei tuoi clienti, anche se generati da software contabili differenti dal tuo.",
          accent: "#b77909",
          accentStrong: "#795006",
          accentSoft: "rgba(183, 121, 9, 0.12)",
          border: "rgba(183, 121, 9, 0.22)",
          actions: [
            {
              label: "Convertitore",
              helper: "Bilancio Analitico",
              product: "bilancio",
              to: "/home/bilancio-analitico",
              variant: "is-primary",
            },
            {
              label: "Libreria",
              helper: "Bilanci Analitici",
              library: "bilanci",
              to: "/home/libreria-bilanci-analitici",
              variant: "is-secondary",
            },
          ],
        },
      ],
    };
  },
  methods: {
    blockGuestUiAction(event) {
      if (!this.isGuestMode) return;

      const target = event.target;
      const allowedTarget = target.closest(
        "a, .guest-action, .icons, .navbar-title, .darkmode-btn, .btn-chiudi, .modal-close, .close-modal, .close-btn, .close-button, .btn-secondary"
      );
      const blockedTarget = target.closest(
        "button, input, select, textarea, label, [role='button'], [contenteditable='true']"
      );

      if (blockedTarget && !allowedTarget) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    },
    goHome() {
      if (this.$route.path !== "/home") {
        const activeChildView = this.$refs.activeChildView;
        if (
          activeChildView &&
          typeof activeChildView.navigateHomeSafely === "function"
        ) {
          activeChildView.navigateHomeSafely();
          return;
        }

        this.$router.push("/home").catch((error) => {
          if (
            error &&
            (error.name === "NavigationAborted" ||
              error.name === "NavigationDuplicated")
          ) {
            return error;
          }
          throw error;
        });
      }
    },
    toggleAccountMenu() {
      this.showAccountMenu = !this.showAccountMenu;
      if (!this.isGuestMode) {
        this.fetchConversionCount();
      }
    },
    handleClickOutside(event) {
      if (
        (this.showBookMenu || this.showConverterMenu) &&
        (this.$refs.bookMenuRef || this.$refs.converterMenuRef) &&
        (!this.$refs.bookMenuRef.contains(event.target) ||
          !this.$refs.converterMenuRef.contains(event.target))
      ) {
        this.showBookMenu = false;
        this.showConverterMenu = false;
      }

      if (
        this.showAccountMenu &&
        this.$refs.accountMenuRef &&
        !this.$refs.accountMenuRef.contains(event.target)
      ) {
        this.showAccountMenu = false;
      }
    },
    logout() {
      localStorage.removeItem("userToken");
      this.$router.replace("/users-login");
    },
    openLogoutModal() {
      this.showModal = true;
      this.$nextTick(() => {
        this.$refs.logoutDialog?.focus();
      });
    },
    closeLogoutModal() {
      if (this.isLoggingOut) return;

      this.showModal = false;
      this.$nextTick(() => {
        document.getElementById("user-menu")?.focus();
      });
    },
    handleLogoutKeydown(event) {
      if (!this.showModal) return;

      if (event.key === "Escape") {
        this.closeLogoutModal();
        return;
      }

      if (event.key !== "Tab" || !this.$refs.logoutDialog) return;

      const focusableElements = Array.from(
        this.$refs.logoutDialog.querySelectorAll(
          "button:not([disabled]), a[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex='-1'])"
        )
      );

      if (!focusableElements.length) {
        event.preventDefault();
        return;
      }

      const firstElement = focusableElements[0];
      const lastElement = focusableElements[focusableElements.length - 1];
      const activeElement = document.activeElement;

      if (
        event.shiftKey &&
        (activeElement === firstElement ||
          activeElement === this.$refs.logoutDialog)
      ) {
        event.preventDefault();
        lastElement.focus();
      } else if (!event.shiftKey && activeElement === lastElement) {
        event.preventDefault();
        firstElement.focus();
      }
    },
    async confirmLogout() {
      if (this.isLoggingOut) return;

      this.isLoggingOut = true;
      try {
        await axios.post(`${API_BASE_URL}/logout`);
        await signOutFromClerk("/users-login");
      } catch (error) {
        console.warn("Logout non completato lato server o Clerk", error);
      } finally {
        localStorage.clear();
        this.$router.replace("/users-login");
      }
    },
    cleanbackend() {},
    setGuestAccountState() {
      this.userEmail = "ospite@mystudio.local";
      this.firstName = "Ospite";
      this.lastName = "";
      this.studioUtente = "Modalità ospite";
      this.creditiRimanenti = 0;
      this.currentPlan = "base";
    },
    exitGuestMode() {
      clearGuestSession();
      this.showAccountMenu = false;
      this.$router.push({ name: "UsersLogin" });
    },
    startGuestRegistration() {
      clearGuestSession();
      this.showAccountMenu = false;
      this.$router.push({
        name: "UsersLogin",
        query: { registrati: "1" },
      });
    },
    fetchConversionCount() {
      if (this.isGuestMode) {
        this.setGuestAccountState();
        return;
      }

      axios
        .get(`${API_BASE_URL}/get_conversion_count`) // ← Niente header!
        .then((response) => {
          this.creditiRimanenti = response.data.crediti_disponibili;
          this.studioUtente = response.data.nome_studio;
        })
        .catch((error) => {
          if (error.response?.status === 401) {
            // Token scaduto → il nostro interceptor lo gestirà automaticamente
            console.log("Token scaduto, refresh in corso...");
          }
        });
    },
    async fetchCurrentPlan() {
      if (this.isGuestMode) {
        this.currentPlan = "base";
        return;
      }

      try {
        const res = await axios.get(`${API_BASE_URL}/abbonamento`);
        this.currentPlan = res.data.current_plan;
      } catch (err) {
        console.error("Errore piano:", err);
      }
    },
    toggleDarkMode() {
      theme.toggle();
      this.isDarkMode = theme.darkMode;
    },
  },
  computed: {
    accountDisplayName() {
      const fullName = [this.firstName, this.lastName]
        .map((part) => String(part || "").trim())
        .filter(Boolean)
        .join(" ");
      return fullName || this.userEmail;
    },
    currentPlanLabel() {
      const plan = String(this.currentPlan || "base").toLowerCase();
      return (
        {
          base: "Base",
          plus: "Plus",
          premium: "Premium",
        }[plan] || "Base"
      );
    },
    planBadgeClass() {
      const plan = String(this.currentPlan || "base").toLowerCase();
      return `account-chip-plan-${plan}`;
    },
    isGuestMode() {
      return isGuestMode();
    },
    isAdmin() {
      if (this.isGuestMode) return false;
      return JSON.parse(localStorage.getItem("isAdmin") || "false");
    },
    isAdminMyStudio() {
      if (this.isGuestMode) return false;
      return JSON.parse(localStorage.getItem("isAdminMyStudio") || "false");
    },
  },
  created() {
    if (this.isGuestMode) {
      this.setGuestAccountState();
    } else {
      this.userEmail = localStorage.getItem("userEmail") || "";
      this.firstName = localStorage.getItem("firstName") || "";
      this.lastName = localStorage.getItem("lastName") || "";
    }
  },
  mounted() {
    this.isDarkMode = theme.darkMode;
    if (this.isGuestMode) {
      this.setGuestAccountState();
    } else {
      this.fetchConversionCount();
      this.fetchCurrentPlan();
    }
    document.addEventListener("click", this.handleClickOutside);
    document.addEventListener("keydown", this.handleLogoutKeydown);
    this.$root.$on("plan-updated", (plan) => {
      this.currentPlan = plan;
    });
    this.$root.$on("user-updated", () => {
      this.firstName = localStorage.getItem("firstName") || "";
      this.lastName = localStorage.getItem("lastName") || "";
    });
  },
  beforeDestroy() {
    document.removeEventListener("click", this.handleClickOutside);
    document.removeEventListener("keydown", this.handleLogoutKeydown);
    this.$root.$off("plan-updated");
  },
};
</script>

<style scoped>
/* Contenitore principale */
.container {
  --app-breadcrumb-height: 2.35rem;
  min-height: 100vh;
  display: flex;
  overflow-x: hidden;
  overflow-y: auto;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start; /* Posizionamento degli elementi in alto */
  background-color: #f9f9f9;
}

.container.home-route {
  height: 100vh;
  overflow-y: hidden;
}

.container.settings-route {
  height: 100dvh;
  min-height: 0;
  overflow: hidden;
}

.container.dashboard-route {
  height: 100dvh;
  min-height: 0;
  overflow: hidden;
}

.container.settings-route footer {
  display: block;
  flex: 0 0 auto;
  margin-top: 0;
  padding: 0.22rem 0 0.32rem;
  font-size: 0.78rem;
  line-height: 1;
  white-space: nowrap;
}

.container.converter-route > .main-container {
  margin-top: calc(-1 * var(--app-breadcrumb-height));
}

@media (min-width: 921px) {
  .container.converter-route {
    height: 100dvh;
    min-height: 0;
    overflow-y: hidden;
  }

  .container.converter-route > .main-container {
    min-height: 0;
  }
}

@media (max-height: 850px) and (min-width: 861px) {
  .container.converter-route footer {
    flex: 0 0 auto;
    padding: 0;
    font-size: 0.72rem;
    line-height: 1;
    white-space: nowrap;
  }
}

@media (max-width: 860px) {
  .container.dashboard-route {
    height: auto;
    min-height: 100dvh;
    overflow-y: auto;
  }

  .container.settings-route {
    height: auto;
    min-height: 100dvh;
    overflow-y: auto;
  }

  .container.settings-route footer {
    display: block;
  }
}

@media (max-width: 860px) {
  .container.settings-route {
    height: auto;
    min-height: 100dvh;
    overflow-y: auto;
  }

  .container.settings-route footer {
    display: block;
  }
}

.container.guest-readonly::after {
  content: "";
  position: fixed;
  inset: 0;
  z-index: 2147483000;
  pointer-events: none;
  background: linear-gradient(
      rgba(247, 250, 248, 0.13),
      rgba(247, 250, 248, 0.13)
    ),
    rgba(238, 242, 240, 0.04);
  box-shadow: inset 0 0 0 9999px rgba(255, 255, 255, 0.015);
}

/* Barra di navigazione */
.navbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: rgb(33, 105, 81);
  /* background-color: #e8f5e9; */
  color: white;
  padding: 0.9rem 0; /* Rimuovi il padding orizzontale */
  min-width: 100%;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.2);
}

.navbar-title {
  font-size: 1.5rem;
  font-weight: 700;
  margin-left: 1.15rem;
  padding: 2px 0px 0px 20px;
  position: relative;
  display: flex;
  align-items: center;
  transition: background-color 0s ease;
  border: 1px solid transparent;
  cursor: pointer;
  width: 14.2rem;
}
.navbar-title:hover {
  background-color: transparent;
  border-radius: 3px;
  border: 1px solid #dddddd00;
  box-shadow: none;
}
.navbar-title-link {
  text-decoration: none;
  font-weight: bold;
  margin-left: 0.15rem;
  /* color: rgb(41, 87, 72); */
  transition: all 0.3s ease;
  cursor: pointer;
  position: relative;
  display: inline-block;
}

.navbar-title-chevron {
  margin-left: 0.78rem;
  font-size: 0.9rem;
  color: #ffffff;
}

.navbar-title:hover::before {
  content: "";
  position: absolute;
  top: 100%;
  left: 0;
  width: min(18rem, calc(100vw - 2rem));
  height: 0.58rem;
  z-index: 9998;
}

.navbar-title:hover::after {
  content: "";
  position: absolute;
  top: calc(100% + 0.08rem);
  left: 2.15rem;
  width: 0.9rem;
  height: 0.9rem;
  background: #ffffff;
  border-top: 1px solid #ebeff1;
  border-left: 1px solid #ebeff1;
  transform: rotate(45deg);
  z-index: 10000;
}

.dropdown-menu-home {
  position: absolute;
  top: calc(100% + 0.5rem);
  left: 0;
  box-sizing: border-box;
  width: min(18rem, calc(100vw - 2rem));
  max-height: calc(100vh - 5.8rem);
  overflow-x: hidden;
  overflow-y: auto;
  padding: 0.92rem 0.86rem 0.88rem;
  background: rgba(255, 255, 255, 0.985);
  border: 1px solid #ebeff1;
  box-shadow: 0 14px 32px rgba(24, 43, 39, 0.18);
  border-radius: 0.72rem;
  z-index: 9999;
  cursor: default;
  scrollbar-width: thin;
  scrollbar-color: #bec7ca transparent;
}

.menu {
  margin-right: 0.5rem;
  cursor: pointer;
}

.home-launcher-section + .home-launcher-section {
  margin-top: 0.82rem;
}

.home-launcher-heading {
  display: flex;
  align-items: center;
  gap: 0.9rem;
  margin: 0 0 0.5rem;
  color: #5d6876;
  font-size: 0.98rem;
  font-weight: 700;
  line-height: 1.2;
}

.home-launcher-heading-line {
  flex: 1;
  height: 1px;
  background: #e9edef;
}

.home-launcher-list {
  display: flex;
  flex-direction: column;
  gap: 0.38rem;
}

.dropdown-item-new {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  box-sizing: border-box;
  width: 100%;
  min-height: 3.28rem;
  padding: 0.34rem 0.5rem;
  text-decoration: none;
  color: #071f1a;
  font-size: 1rem;
  text-align: left;
  background: #ffffff;
  border: 1px solid rgba(215, 223, 227, 0.48);
  border-radius: 0.62rem;
  box-shadow: 0 1px 2px rgba(23, 45, 39, 0.018);
  transition: border-color 0.18s ease, box-shadow 0.18s ease, color 0.18s ease,
    transform 0.18s ease;
}

.dropdown-item-new:not(:last-child) {
  border-bottom-color: rgba(215, 223, 227, 0.48);
}

.dropdown-item-new:hover {
  color: #071f1a;
  background: #ffffff;
  border-color: rgba(198, 211, 206, 0.58);
  box-shadow: 0 8px 18px rgba(29, 74, 59, 0.1);
  transform: translateY(-1px);
}

.home-launcher-icon {
  flex: 0 0 2.25rem;
  width: 2.25rem;
  height: 2.25rem;
  overflow: hidden;
  border-radius: 0.58rem;
  background: #f5f8f7;
}

.home-launcher-icon img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
  transform: scale(1.12);
}

.home-launcher-icon img.home-launcher-icon-emphasis {
  transform: scale(1.2);
}

.home-launcher-icon img.home-launcher-library-icon {
  object-fit: contain;
  transform: scale(1.12);
}

.home-launcher-icon img.home-launcher-library-icon.library-icon--bilanci {
  transform: scale(0.98);
}

.home-launcher-store-fa {
  display: inline-flex;
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: center;
  color: #64748b;
  font-size: 1.5rem;
}

.home-launcher-copy {
  display: flex;
  min-width: 0;
  flex: 1;
  flex-direction: column;
  justify-content: center;
  gap: 0.1rem;
}

.home-launcher-copy strong {
  overflow: hidden;
  color: #071f1a;
  font-size: 0.94rem;
  font-weight: 700;
  line-height: 1.18;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.home-launcher-copy small {
  color: #727d8c;
  font-size: 0.78rem;
  font-weight: 400;
  line-height: 1.2;
}

.home-launcher-chevron {
  flex: 0 0 auto;
  margin: 0 0.28rem 0 auto;
  color: #75808f;
  font-size: 0.86rem;
  transition: transform 0.18s ease;
}

.dropdown-item-new:hover .home-launcher-chevron {
  transform: translateX(2px);
}

.home-launcher-store {
  margin-top: 0.62rem;
  padding-top: 0.62rem;
  border-top: 1px solid #e9edef;
}

.navbar-menu {
  display: flex;
  max-width: 100%;
}

/* Elementi del menu */
.nav-item {
  position: relative;
  width: 4rem;
  padding: 0.6rem; /* Aggiunta di padding per maggiore area cliccabile */
  padding-right: 1.5rem; /* Spazio tra l'elemento e la linea */
  padding-left: 1.5rem; /* Spazio tra la linea e il prossimo elemento */
}

/* Elemento figlio per il testo, che verrà scalato */
.nav-item span {
  display: inline-block;
  transition: transform 0.3s ease; /* Transizione per ingrandimento fluido */
}

@media (min-width: 1100px) and (max-height: 940px) {
  .navbar {
    padding: 0.74rem 0;
  }

  .navbar-title {
    width: 13.55rem;
    margin-left: 1.05rem;
    padding-left: 1.13rem;
    font-size: 1.43rem;
  }

  .logo {
    width: 45px;
  }

  .nav-item {
    padding-top: 0.51rem;
    padding-bottom: 0.51rem;
  }

  .icon,
  .shopicon,
  .icon-tools,
  .navbar .material-icons {
    font-size: 1.51rem;
  }

  .icons::before {
    width: 49px;
    height: 49px;
  }
}

.icons {
  position: relative; /* Aggiungi position relative per il posizionamento del cerchio */
  cursor: pointer;
  transition: transform 0.3s ease; /* Aggiungi una transizione fluida */
  display: inline-block;
  z-index: 1; /* Assicurati che l'icona occupi solo lo spazio necessario */
}

/* Effetto hover solo sul testo, non sul contenitore */
.icons:hover,
.icons.selected {
  transform: scale(1.08); /* Scala solo il testo */
}

.icons.guest-profile-icon {
  opacity: 1;
  filter: none;
}

.icons.guest-profile-icon::before {
  background-color: rgba(255, 255, 255, 0.12);
}

.icons.guest-profile-icon::after {
  content: "";
  position: absolute;
  right: -0.18rem;
  bottom: -0.1rem;
  width: 0.58rem;
  height: 0.58rem;
  border-radius: 50%;
  background: #b8c6c0;
  border: 2px solid rgb(33, 105, 81);
}

.icons.guest-nav-disabled {
  opacity: 0.44 !important;
  filter: grayscale(1) !important;
  cursor: not-allowed !important;
}

.icons.guest-nav-disabled *,
.icons.guest-nav-disabled i {
  cursor: not-allowed !important;
  opacity: 1 !important;
  filter: none !important;
}

.icons.guest-nav-disabled:hover {
  transform: none;
}

.icons.guest-nav-disabled::before {
  background-color: transparent !important;
}

.icons::before {
  content: ""; /* Necessario per mostrare un elemento pseudo */
  position: absolute; /* Posiziona in modo assoluto rispetto all'icona */
  top: 50%; /* Centrato verticalmente */
  left: 50%; /* Centrato orizzontalmente */
  width: 52px; /* Riempi oltre l'icona */
  height: 52px; /* Riempi oltre l'icona */
  border-radius: 50%; /* Rendi l'elemento circolare */
  background-color: transparent; /* Inizialmente trasparente */
  transition: background-color 0.3s ease; /* Transizione per il colore di sfondo */
  transform: translate(-50%, -50%); /* Centra il cerchio */
  z-index: -1; /* Assicurati che il cerchio sia dietro l'icona */
}

/* Mostra il cerchio solo in hover o quando selezionato */
.icons:hover::before,
.icons.selected::before {
  background-color: rgba(255, 255, 255, 0.13);
}

/* Aggiungi una linea di separazione tra gli elementi della navbar */
.nav-item:not(:last-child) {
  border-right: 1px solid #ccc; /* Linea di separazione */
}

/* Stile del menu a tendina */
.dropdown-menu-account {
  position: absolute;
  display: flex;
  flex-direction: column; /* Disporre gli elementi in colonna */
  text-align: left;
  font-size: 0.9rem;
  min-width: 17.25rem;
  top: 100%;
  right: 15px; /* Posiziona il menu a tendina rispetto al lato destro */
  background: rgba(255, 255, 255, 0.98);
  color: #333;
  padding: 1rem 1.2rem 1.05rem;
  border: 1px solid #d9e2de;
  border-radius: 16px;
  box-shadow: 0 16px 38px rgba(16, 24, 20, 0.16);
  z-index: 2000;
  cursor: default;
  white-space: normal;
  margin-right: 0; /* Assicurati che non ci sia margine destro */
  gap: 0.38rem;
}
/* Pulsante Logout */
#user-menu {
  padding: 0.68rem 1rem;
  margin-top: 0.38rem;
  background-color: #dc3545; /* Rosso per logout */
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

#user-menu:hover {
  background-color: #b02a37; /* Rosso più scuro al passaggio */
}
.guest-account-info {
  padding-bottom: 0.9rem;
}

.guest-account-note {
  margin-top: 0.2rem;
  color: #63726c;
  font-size: 0.84rem;
  line-height: 1.4;
}

.guest-menu-disabled,
.guest-register-button,
.guest-exit-button {
  width: 100%;
  margin-top: 0.38rem;
  padding: 0.68rem 1rem;
  border-radius: 5px;
  border: none;
  text-align: center;
  font-weight: 700;
}

.guest-menu-disabled {
  background: #eef1f3;
  color: #7b858c;
  cursor: not-allowed;
  box-shadow: inset 0 0 0 1px #dfe5e8;
}

.guest-disabled-link,
.guest-disabled-link * {
  opacity: 0.56 !important;
  filter: grayscale(0.7) !important;
  cursor: not-allowed !important;
  color: #7b858c !important;
  text-decoration: none !important;
}

.guest-disabled-link:hover,
.guest-disabled-link:hover * {
  color: #7b858c !important;
  background: transparent !important;
}

.guest-register-button {
  background: #216951;
  color: #fff;
  cursor: pointer;
  box-shadow: 0 8px 18px rgba(33, 105, 81, 0.18);
}

.guest-register-button:hover {
  background: #18533f;
}

.guest-register-button:disabled {
  background: #eef1f3;
  color: #7b858c;
  cursor: not-allowed;
  box-shadow: inset 0 0 0 1px #dfe5e8;
}

.guest-register-button:disabled:hover {
  background: #eef1f3;
}

.guest-exit-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.48rem;
  background: #ffffff;
  color: #216951;
  border: 1px solid #96b8aa;
  box-shadow: 0 8px 18px rgba(33, 105, 81, 0.11);
  cursor: pointer;
}

.guest-exit-button:hover {
  background: #eff7f3;
  color: #174d3b;
  border-color: #6e9f8b;
}

#area-personale {
  margin-top: 0.5rem;
  padding: 0.68rem 1rem;
  background-color: #def8e5;
  color: #064e3b;
  border: none;
  border-radius: 5px;
  box-shadow: 0 1px 3px rgb(49 49 49 / 25%);
  cursor: pointer;
  text-align: center;
  transition: all 0.3s ease;
}

#area-personale:hover {
  background-color: rgb(188, 234, 210);
  color: #065f46;
  box-shadow: 0 1px 3px rgb(49 49 49 / 25%);
}
#area-gestionale,
#area-admin {
  margin-top: 0.38rem;
  padding: 0.68rem 1rem;
  background-color: #dce7f5;
  color: #1e3a8a;
  border: none;
  border-radius: 5px;
  box-shadow: 0 1px 3px rgb(49 49 49 / 25%);
  cursor: pointer;
  text-align: center;
  transition: all 0.3s ease;
}

#area-gestionale:hover,
#area-admin:hover {
  background-color: #c0d2ea;
  color: #1e40af;
  box-shadow: 0 1px 3px rgb(49 49 49 / 25%);
}

#settings {
  margin-top: 0.38rem;
  padding: 0.68rem 1rem;
  background-color: #f1f2f3;
  color: #374151;
  border: none;
  border-radius: 5px;
  box-shadow: 0 1px 3px rgb(49 49 49 / 25%);
  cursor: pointer;
  text-align: center;
  transition: all 0.3s ease;
}

#settings:hover {
  background-color: #d6d8db;
  color: #4b5563;
  box-shadow: 0 1px 3px rgb(49 49 49 / 25%);
}
.fa-crown {
  margin-left: 3px;
}

/* Titolo principale */
.header {
  margin-top: 1rem;
  margin-bottom: 1rem;
  text-align: center;
}
/* Contenitore degli input */
.input-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  max-width: 400px;
}

.input-label {
  margin-bottom: 0.5rem;
  font-size: 1rem;
  color: #555;
}

.file-input,
.select-input {
  width: 100%;
  padding: 0.75rem 0 0.75rem 0.75rem;
  margin-bottom: 1.5rem;
  font-size: 1rem;
  border: 1px solid #ccc;
  border-radius: 5px;
  background-color: #fff;
}

.action-button {
  width: 100%;
  padding: 0.75rem;
  background-color: #007bff; /* Azzurro per il pulsante Converti */
  color: #fff;
  border: none;
  border-radius: 5px;
  font-size: 1.1rem;
  cursor: pointer;
  text-align: center;
}

.action-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* Loading spinner */
.loading-message {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 1rem;
}

.spinner {
  width: 28px;
  height: 30px;
  border: 4px solid #f3f3f3;
  border-top: 4px solid #3498db;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-right: 10px;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

/* Messaggio di risposta */
.response-message {
  margin-top: 0.6rem;
  text-align: center;
}

/* Aumenta la dimensione del checkbox */
input[type="checkbox"] {
  margin-left: 10px;
  margin-top: 1px;
  margin-bottom: 5px;
  transform: scale(1.6); /* Scala il checkbox a 1.5x la dimensione originale */
  margin-right: 10px; /* Spazio tra checkbox e l'etichetta */
}

.reset-icon {
  font-size: 0.5rem; /* Dimensione dell'icona */
  color: #3c3f42;
}

.reset-icon:hover {
  color: #6b757d; /* Colore al passaggio del mouse */
}
.standard {
  font-weight: normal;
  padding-top: 0.1rem;
  padding-bottom: 0.1rem;
  font-size: 0.88rem;
}
.icon {
  font-size: 1.6rem;
  transform: scale(1.04); /* Scala solo il testo */
  transition: transform 0.3s ease;
}
.iconConv {
  font-size: 1.6rem;
  transform: scale(1.04); /* Scala solo il testo */
  transition: transform 0.3s ease;
}

.cursor {
  cursor: pointer;
}

.error-message p {
  color: red;
  font-weight: bold;
}

.toggleBox {
  display: flex; /* Usa Flexbox per gestire il layout */
  justify-content: space-between; /* Spinge gli elementi ai bordi */
  align-items: center; /* Centra verticalmente il contenuto */
  width: 100%; /* Può essere opzionale */
}
.piano {
  display: grid;
  align-items: center;
  text-align: left;
  margin-top: 1em;
  border: 2px solid #aaa;
  margin-bottom: -1px; /* Elimina lo spazio tra gli elementi */
  border-radius: 10px; /* Nessun arrotondamento iniziale */
  overflow: hidden; /* Gestione bordi */
}
/* Primo e ultimo elemento con bordi arrotondati */
.piano:first-child {
  border-top-left-radius: 80px;
  border-top-right-radius: 8px;
}
.piano:last-child {
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
}

.accordion-header {
  background-color: white;
  display: flex;
  align-items: center;
  cursor: pointer;
  font-weight: 600;
  padding: 0px 12px 0px 0px;
  transition: background-color 0.3s;
}
.accordion-header:hover {
  background-color: #f0f0f0;
}
.accordion-icon {
  margin-bottom: 5px;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  transition: transform 0.3s ease;
  transform: rotate(180deg); /* Freccia ruotata */
}
.fa-chevron-up {
  transform: rotate(180deg); /* Freccia ruotata */
  transition: transform 0.8s ease;
}
.fa-chevron-right {
  margin-left: 0px;
}
.accordion-content {
  padding: 10px 15px;
  background-color: #fff;
  border-top: 2px solid #aaa;
}
.accordion-enter-active {
  transition: max-height 0.2s ease-in-out, opacity 0.2s ease-in-out;
}

.accordion-enter,
.accordion-leave-to {
  max-height: 0;
  opacity: 0;
}
.titleaccount {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-weight: bold;
  font-size: 1.4em;
  text-align: center !important;
  margin-bottom: 1rem;
}
.pianoIcons {
  padding-top: 0.4rem;
  display: grid;
  grid-template-columns: repeat(3, auto);
  gap: 0.2rem;
}
.pianoicon {
  font-size: 1.3rem;
  background-color: #f7f7f7;
}
.switch {
  position: relative;
  display: inline-block;
  width: 36.96px;
  height: 23.944px;
  vertical-align: middle; /* Assicurati che rimanga centrato */
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 17.5px;
  width: 16px;
  left: 3.5px;
  bottom: 3px;
  background-color: white;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

input:checked + .slider {
  background-color: #2196f3;
}

input:focus + .slider {
  box-shadow: 0 0 1px #2196f3;
}

input:checked + .slider:before {
  -webkit-transform: translateX(16.016px);
  -ms-transform: translateX(16.016px);
  transform: translateX(16.016px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 29.92px;
}

.slider.round:before {
  border-radius: 50%;
}
.accordionicon {
  border: none;
}

.fa-trash-can:hover {
  color: red;
}
#pianoAttualeBase {
  cursor: default;
  color: #5f6a66;
  margin-left: 0.12rem;
}
#pianoAttualePlus {
  cursor: default;
  color: #3a63c8;
  margin-left: 0.12rem;
}
#pianoAttualePremium {
  cursor: default;
  color: #b8841d;
  margin-left: 0.12rem;
}
#creditiAttuali {
  cursor: default;
  color: #2d7d60;
  margin-left: 0.12rem;
}
#nomeStudio {
  cursor: default;
  font-weight: 700;
  font-size: 1.58rem;
  line-height: 1.08;
  letter-spacing: -0.03em;
  color: #233c34;
}
#userEmail {
  cursor: default;
  font-weight: 600;
  font-size: 0.88rem;
  color: #5f6e68;
}
.usericon {
  margin-right: 0;
  color: #7b8b85;
}
.home {
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1 0 auto;
  width: 100%;
  min-height: 0;
}
.home-container {
  width: 80rem;
  max-width: calc(100% - 2rem);
  padding: 20px;
  text-align: center;
  margin: 2rem auto 0;
}

.home-hero-shell {
  width: min(100%, 1140px);
  margin: 0 auto 1.2rem;
  padding: 1rem 1.25rem;
  border-radius: 22px;
  background: linear-gradient(
    180deg,
    rgba(255, 255, 255, 0.9) 0%,
    rgba(248, 250, 248, 0.84) 55%,
    rgba(248, 250, 248, 0.42) 100%
  );
  /* border: 1px solid rgba(141, 174, 160, 0.14);
  box-shadow: 0 8px 18px rgba(22, 42, 34, 0.04); */
}

.home-topbar {
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;
  gap: 1.4rem;
  margin: 0;
}

.guest-home-exit-button {
  min-height: 3.05rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.55rem;
  margin: 0 auto;
  padding: 0.68rem 1.25rem;
  border: 1px solid #216951;
  border-radius: 10px;
  color: #ffffff;
  background: #216951;
  box-shadow: 0 10px 22px rgba(33, 105, 81, 0.18);
  font-size: 0.96rem;
  font-weight: 800;
  cursor: pointer;
  white-space: nowrap;
}

.guest-home-exit-button:hover {
  color: #ffffff;
  background: #18533f;
  border-color: #18533f;
  box-shadow: 0 12px 26px rgba(33, 105, 81, 0.24);
}

.header {
  grid-column: 2;
  text-align: center;
  padding-left: 0;
  transform: translateX(-0.9rem);
}

.header h1 {
  font-size: 2.9rem;
  margin: 0;
  line-height: 1.02;
  color: rgb(33, 105, 81);
}

.header p {
  font-size: 1.2rem;
  color: #6c757d;
}

.tools-grid {
  display: grid;
  grid-template-columns: repeat(
    3,
    minmax(0, 1fr)
  ); /* Forza 3 colonne in una riga */
  gap: 1rem; /* Spazio base tra le card */
  justify-content: center; /* Centra la griglia */
  padding-top: 2.5rem;
  width: min(100%, 1120px);
  margin: 0 auto;
}

.tool-card {
  width: 74%; /* Ridotto al 66% della larghezza */
  max-width: 300px; /* Limite massimo */
  margin: 0 auto; /* Centrare ogni card */
  background: #fff;
  border: 1px solid #ddd;
  border-radius: 10px;
  padding: 20px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  text-align: center;
}

/* Aggiungi margine destro maggiore alla card 1 e 3 per separare i gruppi */
.tool-card:nth-child(2),
.tool-card:nth-child(4),
.tool-card:nth-child(6) {
  margin-right: 20px; /* Spazio maggiore per separare i gruppi */
}

/* Mantieni le coppie 2-3 e 4-5 più vicine */
.tool-card:nth-child(1),
.tool-card:nth-child(3),
.tool-card:nth-child(5) {
  margin-right: 1px; /* Spazio ridotto per mantenere le coppie vicine */
}

.tool-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 12px rgba(0, 0, 0, 0.2);
}

.tool-icon {
  font-size: 3.2rem;
  margin-bottom: 15px;
  color: #2d6a4f;
}

.tool-button {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
  padding: 10px 20px;
  font-size: 1rem;
  background-color: #2d6a4f;
  color: #fff;
  text-decoration: none;
  border-radius: 5px;
  transition: background-color 0.3s ease;
  height: 2.5rem;
}

.tool-button:hover {
  background-color: #1b4332;
}
.tool-button-pdc {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
  padding: 10px 20px;
  font-size: 1rem;
  background-color: #2d96d3;
  color: #fff;
  text-decoration: none;
  border-radius: 5px;
  transition: background-color 0.3s ease;
  height: 2.5rem;
}
.tool-button-pdc:hover {
  background-color: #065a8a;
}
.tool-button-pba {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
  padding: 10px 20px;
  font-size: 1rem;
  background-color: #898989;
  color: #fff;
  text-decoration: none;
  border-radius: 5px;
  transition: background-color 0.3s ease;
  height: 2.5rem;
}
.tool-button-pba:hover {
  background-color: rgb(94, 93, 93);
}

.feature-section {
  width: 100%;
  box-sizing: border-box;
  position: relative;
  display: flex;
  flex-direction: column;
  min-height: 14.75rem;
  padding: 1rem 1.05rem 1.05rem;
  border-radius: 22px;
  text-align: left;
  background: linear-gradient(
      180deg,
      rgba(255, 255, 255, 0.96),
      rgba(248, 250, 248, 0.98)
    ),
    var(--section-accent-soft);
  border: 1px solid var(--section-border);
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  /* box-shadow: 0 22px 44px rgba(18, 32, 26, 0.1); */
  overflow: hidden;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.feature-section::after {
  content: "";
  position: absolute;
  inset: auto -2.7rem -3rem auto;
  width: 8.5rem;
  height: 8.5rem;
  border-radius: 50%;
  background: var(--section-accent-soft);
  filter: blur(2px);
}

.feature-section:hover {
  box-shadow: 0 8px 20px rgba(18, 32, 26, 0.13);
  /* box-shadow: 0 24px 50px rgba(18, 32, 26, 0.13); */
}

.feature-section-top,
.feature-description,
.feature-actions {
  position: relative;
  z-index: 1;
}

.feature-section-top {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 0.85rem;
}

.feature-section-top h4 {
  margin: 0;
  padding: 0.3rem 0.2rem;
  max-width: 70%;
  font-size: 1.22rem;
  line-height: 1.08;
  letter-spacing: -0.04em;
  color: #183a2e;
}

.feature-icon {
  width: 2.95rem;
  height: 2.95rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 20px;
  background: rgba(255, 255, 255, 0.78);
  border: 1px solid var(--section-border);
  color: var(--section-accent-strong);
  box-shadow: 0 8px 18px rgba(18, 32, 26, 0.05);
  font-size: 1rem;
}

.feature-description {
  margin: 0.7rem 0 0;
  font-size: 0.86rem;
  line-height: 1.48;
  color: #5b6e67;
}

.feature-actions {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0.65rem;
  margin-top: auto;
  padding-top: 0.9rem;
}

.feature-action {
  min-width: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 0.2rem;
  min-height: 3.75rem;
  padding: 0.75rem 0.85rem;
  border-radius: 14px;
  text-decoration: none;
  border: 1px solid transparent;
  transition: transform 0.24s ease, box-shadow 0.24s ease,
    border-color 0.24s ease;
}

.feature-action span {
  font-size: 0.93rem;
  font-weight: 700;
}

.feature-action small {
  font-size: 0.74rem;
  line-height: 1.2;
}

.feature-action:hover {
  transform: translateY(-2px);
}

.feature-action.is-primary {
  background: linear-gradient(
    135deg,
    var(--section-accent),
    var(--section-accent-strong)
  );
  color: #fff;
  box-shadow: 0 16px 30px var(--section-accent-soft);
}

.feature-action.is-primary small {
  color: rgba(255, 255, 255, 0.78);
}

.feature-action.is-secondary {
  background: rgba(255, 255, 255, 0.82);
  color: #1f4538;
  border-color: var(--section-border);
}

.feature-action.is-secondary small {
  color: #61716a;
}

.feature-action.is-secondary:hover {
  border-color: var(--section-accent);
  box-shadow: 0 14px 30px var(--section-accent-soft);
}

@media (max-width: 1180px) {
  .tools-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    width: min(100%, 760px);
  }
}

@media (max-width: 760px) {
  .tools-grid {
    grid-template-columns: 1fr;
    width: 100%;
    padding-top: 1.8rem;
  }

  .feature-section {
    min-height: unset;
  }

  .feature-actions {
    grid-template-columns: 1fr;
  }
}

.infoMyStudio {
  text-decoration: none;
  font-weight: bold;
  color: #378843;
  font-size: 1.2rem;
}

.home-footer-action {
  width: 100%;
  margin: 2.4rem 0 0.75rem;
  text-align: center;
}

.infoMyStudio:hover {
  color: #316850;
}
.router-link {
  display: inline-block; /* Come il comportamento predefinito di span */
  padding: 10px; /* Aggiungi padding se necessario per farlo somigliare di più */
  text-decoration: none; /* Rimuovi la sottolineatura del link */
}
.shopicon {
  font-size: 1.6rem;
}
.navbar-menu .icons,
.navbar-menu .icons i,
.navbar-menu .icons a,
.navbar-menu a .icon {
  color: white !important;
  fill: white !important; /* per eventuali SVG */
}
.dropdown-menu-account button,
.dropdown-menu-account router-link > button {
  width: 100% !important;
  text-align: center !important;
}

/* Rimuove eventuali background colorati residui */
.navbar-menu .icons::before {
  background-color: transparent !important;
}
.navbar-menu .icons:hover::before,
.navbar-menu .icons.selected::before {
  background-color: rgba(255, 255, 255, 0.13) !important;
}

.navbar-menu .icons.guest-nav-disabled,
.navbar-menu .icons.guest-nav-disabled *,
.dropdown-menu-home .guest-disabled-link,
.dropdown-menu-home .guest-disabled-link * {
  cursor: not-allowed !important;
}

.navbar-menu .icons.guest-nav-disabled:hover,
.navbar-menu .icons.guest-nav-disabled:hover * {
  transform: none !important;
}

.navbar-menu .icons.guest-nav-disabled:hover::before {
  background-color: transparent !important;
}

.material-icons {
  font-size: 1.6rem !important; /* metti quanto vuoi: 2rem, 2.4rem, 3rem… */
  transform: scale(1.38);
  line-height: 1 !important; /* fondamentale */
  vertical-align: middle !important;
  position: relative;
  transition: all 0.25s ease;
}
.logo {
  width: 48px; /* Regola la dimensione come preferisci */
  height: auto;
  padding-right: 3px;
  cursor: pointer;
  filter: invert(1) brightness(2);
}
footer {
  margin-top: auto;
  padding: 0.75rem 0 1rem;
  color: #65686c;
  font-size: 0.9rem;
}
.logolink {
  all: unset; /* Rimuove TUTTI gli stili ereditati */
  pointer-events: auto; /* Mantiene il click attivo */
  display: contents; /* Fa "sparire" il router-link mantenendo i figli */
}
.dropdown-menu-piani {
  position: absolute;
  display: flex;
  flex-direction: column;
  text-align: left;
  font-size: 0.9rem;
  min-width: 10rem;
  top: 100%;
  right: 0;
  background-color: white;
  color: #333;
  padding: 0.6rem 1.1rem 1.2rem 1.1rem;
  border: 1px solid #ccc;
  border-radius: 5px;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
  z-index: 9999;
  cursor: default;
  white-space: nowrap;
}

.dropdown-button-pdc {
  margin-top: 0.6rem;
  padding: 0.7rem 1rem;
  background-color: #5f8476;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  text-align: center;
}
.dropdown-button-pct {
  margin-top: 0.6rem;
  padding: 0.7rem 1rem;
  background-color: #336987;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  text-align: center;
}
.dropdown-button-pba {
  margin-top: 0.6rem;
  padding: 0.7rem 1rem;
  background-color: #949494;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  text-align: center;
}

.dropdown-button-pdc:hover {
  background-color: #4c6058;
}
.dropdown-button-pct:hover {
  background-color: #274f66;
}
.dropdown-button-pba:hover {
  background-color: #797979;
}
.settingsicon {
  color: #999696;
  cursor: pointer;
  margin-right: 3px;
}

.darkmode-btn {
  position: fixed;
  bottom: 20px;
  right: 20px;
  background: var(--btn-bg, #444);
  border: none;
  color: #fff;
  font-size: 1.5rem;
  padding: 10px 12px;
  border-radius: 50%;
  cursor: pointer;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.3);
  transition: background-color 0.3s ease;
  z-index: 1000;
}
.darkmode-btn:hover {
  background: var(--btn-hover-bg, #666);
}
.darkmode-btn i {
  pointer-events: none;
}
.fa-coins {
  color: #4e4e4e;
  margin-right: 0.25rem;
}
.fa-graduation-cap {
  margin-right: 0.25rem;
  color: #4e4e4e;
}
.menutitles {
  font-weight: bold;
  color: rgb(96, 96, 96);
}
.user-conversion {
  font-weight: bold;
  font-style: italic;
  font-size: 1.1rem;
}
.user-plan {
  font-weight: bold;
  font-style: italic;
  font-size: 1.05rem;
}
p.user-label {
  font-size: 1.1em;
}
.modal-overlay {
  position: fixed;
  inset: 0;
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
}

.logout-modal-overlay {
  padding: 1.25rem;
  background: rgba(17, 27, 34, 0.58);
  backdrop-filter: blur(3px);
}

.modal-content.logout-confirmation {
  position: relative;
  width: min(27rem, calc(100vw - 2.5rem));
  padding: 0;
  overflow: hidden;
  background: #ffffff;
  border: 1px solid rgba(19, 52, 72, 0.1);
  border-radius: 0.9rem;
  box-shadow: 0 1.5rem 4rem rgba(11, 31, 43, 0.28);
  text-align: center;
  display: flex;
  flex-direction: column;
  outline: none;
}

.modal-content.logout-confirmation h3 {
  margin: 0;
  color: #0a2940;
  font-size: 1.55rem;
  font-weight: 750;
  line-height: 1.2;
}

.modal-content.logout-confirmation p {
  max-width: 22rem;
  margin: 0.55rem 0 0;
  color: #5d6c76;
  font-size: 0.95rem;
  line-height: 1.45;
}

.logout-modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 3.35rem;
  padding: 0.8rem 1rem 0.35rem 1.25rem;
}

.logout-brand {
  color: #647079;
  font-size: 0.65rem;
  font-weight: 800;
  letter-spacing: 0.24em;
  text-transform: uppercase;
}

.logout-close-button {
  width: 2.15rem;
  height: 2.15rem;
  padding: 0;
  border: 0;
  border-radius: 50%;
  background: #f0f2f4;
  color: #758089;
  font-size: 1rem;
  cursor: pointer;
  transition: background-color 0.18s ease, color 0.18s ease,
    transform 0.18s ease;
}

.logout-close-button:hover:not(:disabled) {
  background: #e7eaed;
  color: #35434d;
  transform: rotate(4deg);
}

.logout-close-button:focus-visible,
.logout-button:focus-visible {
  outline: 3px solid rgba(22, 136, 95, 0.25);
  outline-offset: 2px;
}

.logout-close-button:disabled,
.logout-button:disabled {
  cursor: wait;
  opacity: 0.7;
}

.logout-modal-intro {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0.15rem 2rem 1.15rem;
}

.logout-main-icon {
  display: grid;
  place-items: center;
  width: 3.55rem;
  height: 3.55rem;
  margin-bottom: 0.9rem;
  border-radius: 50%;
  background: #fde4e8;
  color: #ed2945;
  font-size: 1.45rem;
}

.logout-summary {
  margin: 0 1.5rem 1rem;
  padding: 0.15rem 0.9rem;
  border: 1px solid rgba(21, 133, 92, 0.08);
  border-radius: 0.7rem;
  background: linear-gradient(115deg, #edf9f4 0%, #f4fbf8 100%);
  text-align: left;
}

.logout-summary-row {
  display: grid;
  grid-template-columns: 2.55rem minmax(0, 1fr);
  align-items: center;
  gap: 0.75rem;
  min-height: 4rem;
  padding: 0.5rem 0.15rem;
}

.logout-summary-row + .logout-summary-row {
  border-top: 1px solid rgba(21, 92, 68, 0.1);
}

.logout-summary-icon {
  display: grid;
  place-items: center;
  width: 2.55rem;
  height: 2.55rem;
  border-radius: 50%;
  background: #d9f3e8;
  color: #087452;
  font-size: 1.05rem;
}

.logout-summary-copy {
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 0.08rem;
}

.logout-summary-label {
  color: #66766f;
  font-size: 0.82rem;
  line-height: 1.15;
}

.logout-summary-copy strong {
  overflow: hidden;
  color: #17533e;
  font-size: 0.95rem;
  line-height: 1.25;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.logout-modal-actions {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0.7rem;
  padding: 0.9rem 1.5rem 1.2rem;
  border-top: 1px solid #edf0f2;
  background: #fbfcfd;
}

.logout-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.55rem;
  min-height: 2.8rem;
  padding: 0.65rem 1rem;
  border: 1px solid transparent;
  border-radius: 0.45rem;
  font-size: 0.92rem;
  font-weight: 700;
  cursor: pointer;
  transition: border-color 0.18s ease, background-color 0.18s ease,
    box-shadow 0.18s ease, transform 0.18s ease;
}

.logout-button-secondary {
  border-color: #e8ebee;
  background: #f0f2f4;
  color: #4e5962;
}

.logout-button-secondary:hover:not(:disabled) {
  border-color: #dce1e5;
  background: #e8ebee;
}

.logout-button-danger {
  background: linear-gradient(135deg, #ef334f 0%, #e8203f 100%);
  color: white;
  box-shadow: 0 0.45rem 1rem rgba(232, 32, 63, 0.18);
}

.logout-button-danger:hover:not(:disabled) {
  background: linear-gradient(135deg, #e92b47 0%, #d91836 100%);
  box-shadow: 0 0.55rem 1.2rem rgba(217, 24, 54, 0.24);
  transform: translateY(-1px);
}

.logout-modal-enter-active,
.logout-modal-leave-active {
  transition: opacity 0.18s ease;
}

.logout-modal-enter-active .logout-confirmation,
.logout-modal-leave-active .logout-confirmation {
  transition: opacity 0.18s ease, transform 0.18s ease;
}

.logout-modal-enter,
.logout-modal-leave-to {
  opacity: 0;
}

.logout-modal-enter .logout-confirmation,
.logout-modal-leave-to .logout-confirmation {
  opacity: 0;
  transform: translateY(0.75rem) scale(0.985);
}

@media (max-width: 30rem) {
  .logout-modal-overlay {
    padding: 0.75rem;
  }

  .modal-content.logout-confirmation {
    width: calc(100vw - 1.5rem);
  }

  .logout-modal-intro {
    padding-inline: 1.35rem;
  }

  .logout-summary {
    margin-inline: 1rem;
  }

  .logout-modal-actions {
    padding-inline: 1rem;
  }
}
.infoaccount {
  display: flex;
  flex-direction: column;
  gap: 0.42rem;
  align-items: stretch;
  width: 100%;
  margin-top: 0;
  padding: 0.05rem 0 0.62rem;
  border-bottom: 1px solid #e7ece9;
}

.account-eyebrow {
  margin: 0;
  font-size: 0.69rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #7b8b85;
}

.account-title-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
}

.account-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 0.72rem;
}

.account-chip {
  display: flex;
  align-items: center;
  gap: 0.38rem;
  min-height: 1.6rem;
  padding: 0.12rem 0;
  border-radius: 0;
  font-size: 0.84rem;
  font-weight: 600;
  line-height: 1;
  background: transparent;
  border: none;
}

.account-chip i {
  color: #6d7d76;
  margin-right: 0;
}

.account-chip-plan {
  background: transparent;
  border: none;
}

.account-chip-coin {
  background: transparent;
  border: none;
  position: relative;
  margin-left: 0.12rem;
  padding-left: 0.72rem;
}

.account-chip-coin::before {
  content: "";
  position: absolute;
  left: 0;
  top: 50%;
  width: 1px;
  height: 0.9rem;
  background: #d8dfdc;
  transform: translateY(-50%);
}

.account-chip-label {
  color: #6d7d76;
  font-size: 0.76rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.user-label,
.user-studio,
.user-plan,
.user-conversion,
.account-user-row {
  display: flex;
  align-items: center;
}

.account-user-row {
  gap: 0.5rem;
  margin: 0;
  padding: 0.06rem 0 0;
  color: #65746e;
}

.account-user-text {
  display: block;
  line-height: 1.3;
}
#nomeStudio,
#userEmail,
#pianoAttualeBase,
#pianoAttualePlus,
#pianoAttualePremium,
#creditiAttuali {
  font-weight: bold; /* Mantieni il testo in grassetto per consistenza */
}
/* Icona "9 puntini" stile Google */
.icon-tools {
  font-size: 1.6rem;
  transform: scale(1.04);
}
.google-apps-menu {
  position: absolute;
  top: 100%;
  right: 8px;
  background: white;
  border-radius: 12px;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.3);
  padding: 25px;
  width: 330px;
  border: 1px solid #dadce0;
  z-index: 9999;
}

.apps-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
  padding: 0;
}

.apps-section-label {
  grid-column: 1 / -1;
  margin: 0;
  padding: 0 0 0.1rem 0.15rem;
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #6b7280;
}

.app-item {
  display: flex !important;
  flex-direction: column !important;
  align-items: center;
  justify-content: baseline;
  text-align: center;
  width: 100%;
  box-sizing: border-box;
  padding: 7px 6px 9px 6px;
  text-decoration: none;
  background: #fbfcfd;
  color: #5f6368;
  font-family: "Sora", "Manrope", "Inter", system-ui, sans-serif;
  font-weight: 600;
  letter-spacing: -0.2px;
  font-size: 0.84rem;
  border-radius: 12px;
  border: 1px solid #eef1f3;
  transition: background 0.2s, border-color 0.2s;
}

.app-item:hover {
  background: #f5f7f8;
  border-color: #e3e7ea;
  border-radius: 12px;
}

.app-item-paghe {
  background: #fbfcfd;
  border: 1px solid #eef1f3;
}

.app-item-paghe:hover {
  background: #f5f7f8;
  border-color: #e3e7ea;
}

.app-item-f24 {
  background: #fbfcfd;
  border: 1px solid #eef1f3;
}

.app-item-f24:hover {
  background: #f5f7f8;
  border-color: #e3e7ea;
}

.app-item-bilancio {
  background: #fbfcfd;
  border: 1px solid #eef1f3;
}

.app-item-bilancio:hover {
  background: #f5f7f8;
  border-color: #e3e7ea;
}

.app-icon {
  width: 56px;
  height: 40px;
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 8px;
  font-size: 26px;
  color: rgb(255, 255, 255);
  flex-shrink: 0;
}

.app-label {
  width: 100%;
  line-height: 1.25;
  word-break: break-word;
  min-height: 2.7em;
  max-height: 2.7em;
  overflow: hidden;
  padding: 0 4px;
}

.app-icon i {
  font-size: 2rem;
}

.app-icon .product-icon,
.app-icon .library-icon {
  width: 2.6rem;
  height: 2.6rem;
  transform: scale(1.08);
}
/* COLORI */
.app-icon.green {
  color: #4f7a69;
}
.app-icon.blue {
  color: #336987;
}
.app-icon.gray {
  color: #aa8335;
}
/* ====================== ANAGRAFICA CLIENTI A SINISTRA ====================== */
.anagrafica-left {
  grid-column: 3;
  justify-self: end;
  margin: 0;
  padding-right: 2.2rem;
  text-decoration: none;
}

.anagrafica-left-inner {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 0.5rem;
  transform: translateY(0.8rem);
}

.home-shortcut {
  margin: 0; /* reset margini precedenti */
  padding: 0.58rem 0.88rem;
  width: 13rem;
  font-size: 0.82rem;
  /* font-weight: bold; */
  unicode-bidi: isolate;
  /* background-color: #dce7f5; */
  background-color: #fff;
  /* color: #2c3e50; */
  color: #185084;
  border: 1px solid #e2e2e2;
  border-radius: 10px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.11);
  cursor: pointer;
  transition: none;
  display: flex;
  align-items: center;
  gap: 0.7rem;
}
.anagrafica-left a {
  text-decoration: none !important;
}

.home-shortcut:hover {
  background-color: #ffd04d;
  color: #2c3e50;
  transform: translateY(-2px);
  transition: all 0.3s ease;
  box-shadow: 0 3px 8px rgba(0, 0, 0, 0.2);
}

.home-shortcut i {
  font-size: 1.2rem;
}

/* ====================== MENU ACCOUNT HOME ====================== */
.dropdown-menu-account.account-menu-authenticated {
  --account-font: "Inter", "Segoe UI Variable Text", "Segoe UI", sans-serif;
  --account-title-font: "Manrope", "Inter", "Segoe UI Variable Display",
    "Segoe UI", sans-serif;
  --account-gold: #d9a20b;
  width: min(19rem, calc(100vw - 1.5rem));
  min-width: min(19rem, calc(100vw - 1.5rem));
  top: calc(100% + 0.25rem);
  right: 0.9rem;
  gap: 0.48rem;
  padding: 1.08rem 1.35rem 1.15rem;
  border: 1px solid rgba(208, 221, 229, 0.95);
  border-radius: 20px;
  background: rgba(255, 255, 255, 0.98);
  box-shadow: 0 22px 48px rgba(15, 37, 55, 0.18);
  font-family: var(--account-font);
}

.dropdown-menu-account.account-menu-authenticated::before {
  content: "";
  position: absolute;
  top: -0.48rem;
  right: 2.82rem;
  width: 0.9rem;
  height: 0.9rem;
  transform: rotate(45deg);
  border-left: 1px solid rgba(208, 221, 229, 0.95);
  border-top: 1px solid rgba(208, 221, 229, 0.95);
  background: rgba(255, 255, 255, 0.98);
}

.account-menu-authenticated .infoaccount {
  gap: 0.7rem;
  padding: 0 0 0.78rem;
  border-bottom: 1px solid #e3e9ee;
}

.account-menu-authenticated .account-eyebrow {
  color: #607083;
  font-family: var(--account-font);
  font-size: 0.7rem;
  font-weight: 800;
  letter-spacing: 0.18em;
  text-transform: uppercase;
}

.account-menu-authenticated .account-profile-row {
  display: flex;
  align-items: center;
  gap: 0.78rem;
}

.account-menu-authenticated .account-studio-avatar {
  flex: 0 0 3.75rem;
  width: 3.75rem;
  height: 3.75rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 999px;
  background: radial-gradient(
    circle at 35% 25%,
    #fafbfc 0,
    #f1f3f5 58%,
    #e8ecef 100%
  );
  color: #354968;
  font-size: 1.55rem;
}

.account-menu-authenticated .account-title-stack {
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 0.28rem;
}

.account-menu-authenticated #nomeStudio {
  color: #10243d !important;
  font-family: var(--account-title-font) !important;
  font-size: 1.46rem !important;
  font-weight: 800 !important;
  line-height: 1.08;
  letter-spacing: -0.045em;
}

.account-menu-authenticated .account-user-row {
  display: inline-flex;
  align-items: center;
  gap: 0.42rem;
  margin: 0;
  padding: 0;
  color: #687386 !important;
  font-family: var(--account-font) !important;
  font-size: 0.92rem !important;
  font-weight: 700 !important;
}

.account-menu-authenticated .usericon {
  color: #778192;
  font-size: 0.86rem;
}

.account-menu-authenticated #userEmail {
  color: #667085 !important;
  font-family: var(--account-font) !important;
  font-size: 0.92rem !important;
  font-weight: 700 !important;
}

.account-menu-authenticated .account-meta {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0;
  overflow: hidden;
  border-radius: 10px;
  background: linear-gradient(135deg, #f4f6f7, #e9edf0);
}

.account-menu-authenticated .account-chip {
  min-height: 2.85rem !important;
  padding: 0.48rem 1rem !important;
  border: 0 !important;
  border-radius: 0 !important;
  box-sizing: border-box;
  display: grid !important;
  grid-template-columns: 1.8rem minmax(0, 1fr);
  align-items: center;
  column-gap: 0.75rem;
  background: transparent !important;
  font-family: var(--account-font) !important;
  user-select: none;
}

.account-menu-authenticated .account-chip i {
  width: 1.8rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 1.32rem !important;
  line-height: 1;
}

.account-menu-authenticated .account-chip-copy {
  min-width: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: 0.16rem;
  line-height: 1;
  white-space: nowrap;
}

.account-menu-authenticated .account-chip-label {
  color: #738293 !important;
  display: block;
  font-family: var(--account-font) !important;
  font-size: 0.68rem !important;
  font-weight: 800 !important;
  letter-spacing: 0.11em;
  line-height: 1;
  text-transform: uppercase;
  white-space: nowrap;
}

.account-menu-authenticated .account-plan-value,
.account-menu-authenticated #creditiAttuali {
  display: block;
  margin: 0 !important;
  font-family: var(--account-title-font) !important;
  font-size: 1.05rem !important;
  font-weight: 700 !important;
  line-height: 1;
  letter-spacing: -0.035em;
  white-space: nowrap;
  color: #18304a !important;
}

.account-menu-authenticated .account-chip-plan-premium {
  background: transparent !important;
}

.account-menu-authenticated .account-chip-plan {
  cursor: pointer;
  text-decoration: none;
  transition: background 0.18s ease;
}

.account-menu-authenticated .account-chip-plan:hover {
  background: rgba(255, 255, 255, 0.42) !important;
}

.account-menu-authenticated .account-chip-plan-plus {
  background: transparent !important;
}

.account-menu-authenticated .account-chip-plan-base {
  background: transparent !important;
}

.account-menu-authenticated .account-chip-coin {
  margin: 0;
  border-left: 1px solid #d5dde3 !important;
  background: transparent !important;
}

.account-menu-authenticated .account-chip-coin::before {
  content: none;
}

.account-menu-authenticated .account-chip-plan i,
.account-menu-authenticated .account-chip-coin i {
  color: #52677d;
}

.account-menu-authenticated .account-chip-coin-link {
  cursor: pointer;
  text-decoration: none;
  transition: background 0.18s ease, border-color 0.18s ease,
    box-shadow 0.18s ease;
}

.account-menu-authenticated .account-chip-coin-link #creditiAttuali {
  cursor: pointer;
}

.account-menu-authenticated .account-chip-coin-link:hover {
  background: rgba(255, 255, 255, 0.42) !important;
}

.account-menu-authenticated .account-chip-coin-link:focus-visible {
  outline: 2px solid var(--account-gold);
  outline-offset: 2px;
}

.account-menu-authenticated .account-chip-plan,
.account-menu-authenticated .account-chip-coin {
  border: 0 !important;
  background: transparent !important;
}

.account-menu-authenticated .account-chip-coin {
  border-left: 1px solid #d5dde3 !important;
}

.account-menu-authenticated .account-action-link {
  display: block;
  padding: 0;
  text-decoration: none;
}

.dropdown-menu-account.account-menu-authenticated .account-action {
  width: 100% !important;
  min-height: 2.95rem;
  display: grid;
  grid-template-columns: 1.75rem 1fr auto;
  align-items: center;
  gap: 0.6rem;
  margin: 0;
  padding: 0.58rem 0.78rem;
  border: 0;
  border-radius: 13px;
  box-sizing: border-box;
  text-align: left !important;
  font-family: var(--account-font);
  font-size: 0.94rem;
  font-weight: 700;
  box-shadow: 0 6px 15px rgba(15, 37, 55, 0.09);
  cursor: pointer;
  transition: transform 0.18s ease, box-shadow 0.18s ease,
    background-color 0.18s ease;
}

.dropdown-menu-account.account-menu-authenticated .account-action:hover {
  transform: translateY(-1px);
  box-shadow: 0 10px 20px rgba(15, 37, 55, 0.12);
}

.account-menu-authenticated .account-action > i:first-child {
  justify-self: center;
  font-size: 1.04rem;
}

.account-menu-authenticated .account-action-chevron {
  color: #7a8798;
  font-size: 0.96rem;
}

.account-menu-authenticated #area-personale.account-action {
  background: linear-gradient(135deg, #dcfbe8, #d1f5de);
  color: #064e3b;
}

.account-menu-authenticated #area-gestionale.account-action {
  background: linear-gradient(135deg, #e8f1ff, #dceafe);
  color: #174c9a;
}

.account-menu-authenticated #area-admin.account-action {
  background: linear-gradient(135deg, #fff4d6, #ffe5ae);
  color: #965800;
}

.account-menu-authenticated #settings.account-action {
  background: linear-gradient(135deg, #f7f8fa, #edf1f4);
  color: #1f2937;
}

.account-menu-authenticated #settings.account-action .settingsicon {
  color: #6b7280;
  font-size: 1.25rem;
}

.dropdown-menu-account.account-menu-authenticated #user-menu.account-action {
  background: linear-gradient(135deg, #ffe0e5, #ffd1da);
  color: #c81e3a;
  border: 0;
}

.dropdown-menu-account.account-menu-authenticated
  #user-menu.account-action:hover {
  background: linear-gradient(135deg, #ffd8df, #ffc6d0);
}

/* Menu account in modalità ospite */
.dropdown-menu-account.account-menu-guest {
  --account-font: "Inter", "Segoe UI Variable Text", "Segoe UI", sans-serif;
  --account-title-font: "Manrope", "Inter", "Segoe UI Variable Display",
    "Segoe UI", sans-serif;
  width: min(19rem, calc(100vw - 1.5rem));
  min-width: min(19rem, calc(100vw - 1.5rem));
  top: calc(100% + 0.25rem);
  right: 0.9rem;
  gap: 0.48rem;
  padding: 1.08rem 1.35rem 1.15rem;
  border: 1px solid rgba(208, 221, 229, 0.95);
  border-radius: 20px;
  background: rgba(255, 255, 255, 0.98);
  box-shadow: 0 22px 48px rgba(15, 37, 55, 0.18);
  font-family: var(--account-font);
}

.dropdown-menu-account.account-menu-guest::before {
  content: "";
  position: absolute;
  top: -0.48rem;
  right: 2.82rem;
  width: 0.9rem;
  height: 0.9rem;
  border-top: 1px solid rgba(208, 221, 229, 0.95);
  border-left: 1px solid rgba(208, 221, 229, 0.95);
  background: rgba(255, 255, 255, 0.98);
  transform: rotate(45deg);
}

.account-menu-guest .guest-account-info {
  padding: 0 0 0.9rem;
  border-bottom: 1px solid #e3e9ee;
}

.account-menu-guest .account-eyebrow {
  color: #607083;
  font-size: 0.7rem;
  font-weight: 800;
  letter-spacing: 0.18em;
  text-transform: uppercase;
}

.account-menu-guest #nomeStudio {
  color: #21493c !important;
  font-family: var(--account-title-font) !important;
  font-size: 1.46rem !important;
  font-weight: 800 !important;
  line-height: 1.1;
  letter-spacing: -0.035em;
}

.account-menu-guest .guest-account-note {
  margin-top: 0.65rem;
  color: #697a72;
  font-size: 0.86rem;
  line-height: 1.45;
}

.dropdown-menu-account.account-menu-guest .guest-account-action {
  display: grid;
  grid-template-columns: 1.75rem minmax(0, 1fr) auto;
  align-items: center;
  gap: 0.6rem;
  width: 100%;
  min-height: 2.95rem;
  box-sizing: border-box;
  margin: 0;
  padding: 0.58rem 0.78rem;
  border: 0;
  border-radius: 13px;
  font-family: var(--account-font);
  font-size: 0.94rem;
  font-weight: 700;
  text-align: left;
}

.account-menu-guest .guest-account-action > i:first-child {
  justify-self: center;
  font-size: 1.04rem;
}

.account-menu-guest .account-action-chevron {
  color: #849089;
  font-size: 0.9rem;
}

.account-menu-guest .guest-action-personal {
  background: linear-gradient(135deg, #e4f6eb, #daf1e3);
  color: #245f49;
}

.account-menu-guest .guest-action-studio {
  background: linear-gradient(135deg, #eaf1f8, #e1ebf4);
  color: #3f6381;
}

.account-menu-guest .guest-action-settings {
  background: linear-gradient(135deg, #f4f6f7, #e9eef0);
  color: #58646d;
}

.account-menu-guest .guest-action-register {
  background: linear-gradient(135deg, #def6e7, #d3efdd);
  color: #155d40;
  box-shadow: 0 6px 15px rgba(33, 105, 81, 0.09);
  cursor: pointer;
  transition: background 0.18s ease, box-shadow 0.18s ease, transform 0.18s ease;
}

.account-menu-guest .guest-action-register:hover {
  background: linear-gradient(135deg, #d4f1df, #c8ead5);
  box-shadow: 0 9px 19px rgba(33, 105, 81, 0.14);
  transform: translateY(-1px);
}

.dropdown-menu-account.account-menu-guest .guest-account-action:disabled {
  cursor: not-allowed;
  opacity: 0.72;
  box-shadow: none;
}

.dropdown-menu-account.account-menu-guest .guest-exit-button {
  grid-template-columns: 1.75rem minmax(0, 1fr);
  margin-top: 0.25rem;
  border: 1px solid #9bbdad;
  background: #fff;
  color: #216951;
  box-shadow: 0 7px 16px rgba(33, 105, 81, 0.09);
  cursor: pointer;
}

.dropdown-menu-account.account-menu-guest .guest-exit-button:hover {
  border-color: #72a08c;
  background: #eff7f3;
  color: #174d3b;
}
/* .home-shortcut:hover > i {
  color: #ffd04d;
} */

@media (max-width: 980px) {
  .home-hero-shell {
    padding: 0.95rem 1rem;
  }

  .home-topbar {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 0;
  }

  .header {
    transform: none;
    padding-left: 0;
    text-align: center;
  }

  .anagrafica-left {
    margin-top: 0;
    padding-right: 0;
  }

  .anagrafica-left-inner {
    align-items: center;
    transform: none;
  }
}

@media (max-width: 760px) {
  .home-hero-shell {
    padding: 0.9rem 0.85rem;
    border-radius: 18px;
    margin-bottom: 1rem;
  }

  .home-topbar {
    gap: 1rem;
  }

  .header {
    width: 100%;
    text-align: center;
  }

  .anagrafica-left {
    width: 100%;
  }

  .anagrafica-left a {
    width: 100%;
    display: flex;
    justify-content: center;
  }

  .home-shortcut {
    width: min(100%, 320px);
    justify-content: center;
  }

  .guest-home-exit-button {
    width: min(100%, 320px);
  }
}

/* Home dashboard */
.container.home-route {
  height: 100dvh;
  min-height: 0;
  overflow: hidden;
}

.container.home-route footer {
  display: block;
  flex: 0 0 auto;
  margin-top: 0;
  padding: 0.22rem 0 0.32rem;
  font-size: 0.78rem;
  line-height: 1;
  white-space: nowrap;
}

.home {
  box-sizing: border-box;
  flex: 1 1 auto;
  min-height: 0;
  padding: clamp(0.6rem, calc(4dvh - 1rem), 1.5rem) 0;
  overflow-x: hidden;
  overflow-y: hidden;
}

.home-container {
  box-sizing: border-box;
  display: grid;
  flex: 1 1 auto;
  grid-template-rows:
    minmax(0, 26fr)
    minmax(21.5rem, 51fr)
    minmax(0, 9fr);
  gap: clamp(0.5rem, calc(4dvh - 1rem), 1.4rem);
  width: min(84vw, 95rem);
  height: 100%;
  min-height: 0;
  margin: 0 auto;
  padding: 0;
  text-align: left;
}

.home-hero-shell {
  position: relative;
  display: flex;
  min-height: 0;
  align-items: center;
  justify-content: space-between;
  gap: clamp(1.5rem, 3vw, 3.2rem);
  width: 94%;
  margin: 0 auto;
  padding: clamp(1.25rem, 2.25vw, 2.15rem);
  box-sizing: border-box;
  overflow: hidden;
  border: 0;
  border-radius: clamp(1rem, 1.4vw, 1.5rem);
  background: linear-gradient(105deg, #f2f6f9 0%, #edf3f7 55%, #e8f0f5 100%);
  box-shadow: 0 12px 30px rgba(62, 85, 105, 0.08);
}

.home-hero-copy {
  position: relative;
  z-index: 1;
  min-width: 0;
  max-width: 50%;
  color: #20364a;
}

.home-eyebrow {
  display: block;
  margin-bottom: clamp(0.4rem, 0.8vh, 0.65rem);
  color: #63728a;
  font-size: clamp(0.74rem, 0.86vw, 0.9rem);
  font-weight: 800;
  letter-spacing: 0.03em;
  text-transform: uppercase;
}

.home-hero-copy h1 {
  margin: 0;
  color: #173247;
  font-family: "Manrope", "Inter", "Segoe UI Variable Display", sans-serif;
  font-size: clamp(1.85rem, 2.55vw, 3rem);
  font-weight: 800;
  line-height: 1.05;
  letter-spacing: -0.035em;
  white-space: nowrap;
}

.home-hero-copy p {
  margin: clamp(0.55rem, 1.25vh, 0.9rem) 0 0;
  color: #627189;
  font-size: clamp(0.84rem, 1.12vw, 1.18rem);
  line-height: 1.42;
}

.home-hero-visual {
  position: absolute;
  z-index: 0;
  top: 0;
  right: 26%;
  bottom: 0;
  left: 38%;
  overflow: hidden;
  pointer-events: none;
  -webkit-mask-image: linear-gradient(
    90deg,
    transparent 0%,
    #000 12%,
    #000 100%
  );
  mask-image: linear-gradient(90deg, transparent 0%, #000 12%, #000 100%);
}

.home-hero-art {
  position: absolute;
  top: 50%;
  right: -0.9rem;
  display: block;
  width: auto;
  max-width: none;
  height: 150%;
  pointer-events: none;
  transform: translateY(-50%);
}

.home-shortcuts {
  position: relative;
  z-index: 1;
  display: flex;
  width: clamp(17rem, 20vw, 19.5rem);
  flex: 0 0 auto;
  flex-direction: column;
  gap: clamp(0.55rem, 1vh, 0.85rem);
  margin-left: auto;
}

.home-shortcut {
  display: grid;
  grid-template-columns: 2rem minmax(0, 1fr) auto;
  align-items: center;
  gap: 0.85rem;
  box-sizing: border-box;
  width: 100%;
  min-height: clamp(3.15rem, 6.4vh, 4.55rem);
  margin: 0;
  padding: 0.75rem 1.15rem;
  border: 1px solid rgba(222, 229, 227, 0.92);
  border-radius: 0.82rem;
  color: #102d54;
  background: #ffffff;
  box-shadow: 0 8px 20px rgba(27, 55, 48, 0.08);
  cursor: pointer;
  font-family: inherit;
  font-size: clamp(0.88rem, 1vw, 1.05rem);
  font-weight: 700;
  text-align: left;
  text-decoration: none;
  transition: border-color 0.18s ease, box-shadow 0.18s ease,
    transform 0.18s ease;
}

.home-shortcut:hover {
  color: #102d54;
  background: #ffffff;
  border-color: rgba(33, 105, 81, 0.3);
  box-shadow: 0 12px 26px rgba(27, 55, 48, 0.13);
  transform: translateY(-1px);
}

.home-shortcut.is-disabled,
.home-shortcut.is-disabled:hover {
  grid-template-columns: 2rem minmax(0, 1fr);
  border-color: rgba(164, 188, 177, 0.72);
  background: rgba(255, 255, 255, 0.72);
  color: #445a50;
  box-shadow: 0 6px 16px rgba(27, 55, 48, 0.06);
  cursor: not-allowed;
  opacity: 1;
  transform: none;
}

.home-shortcut > i:first-child {
  color: #49677f;
  font-size: clamp(1.2rem, 1.55vw, 1.65rem);
  text-align: center;
  transition: color 0.18s ease;
}

.home-shortcut > i:last-child {
  color: #71879a;
  font-size: 0.9rem;
  transition: color 0.18s ease;
}

.home-shortcut:hover > i:first-child,
.home-shortcut:hover > i:last-child,
.home-shortcut:focus-visible > i:first-child,
.home-shortcut:focus-visible > i:last-child {
  color: #07815e;
}

.home-shortcut.is-disabled > i:first-child,
.home-shortcut.is-disabled > i:last-child,
.home-shortcut.is-disabled:hover > i:first-child,
.home-shortcut.is-disabled:hover > i:last-child {
  color: #7c8f9e;
}

.tools-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: clamp(0.72rem, 1.4vw, 1.25rem);
  align-self: center;
  min-height: 0;
  height: 90%;
  width: 94%;
  margin: 0 auto;
  padding: 0;
  justify-self: center;
}

.feature-section {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: 0;
  padding: clamp(0.8rem, 2dvh, 1.35rem) clamp(1rem, 1.3vw, 1.45rem);
  box-sizing: border-box;
  overflow: hidden;
  border: 1px solid var(--section-border);
  border-radius: clamp(1rem, 1.35vw, 1.45rem);
  background: linear-gradient(
    145deg,
    #ffffff 28%,
    rgba(255, 255, 255, 0.98) 62%,
    var(--section-accent-soft) 180%
  );
  box-shadow: 0 10px 26px rgba(21, 44, 37, 0.07);
  text-align: left;
  transition: border-color 0.18s ease, box-shadow 0.18s ease,
    transform 0.18s ease;
}

.feature-section::after {
  content: none;
}

.feature-section:hover {
  border-color: var(--section-accent);
  box-shadow: 0 14px 32px rgba(21, 44, 37, 0.11);
  transform: translateY(-1px);
}

.feature-section-top {
  display: flex;
  flex: 0 0 auto;
  align-items: center;
  justify-content: space-between;
  gap: 0.65rem;
}

.feature-heading {
  display: flex;
  min-width: 0;
  align-items: center;
  gap: clamp(0.6rem, 0.85vw, 0.85rem);
}

.feature-section-top h2 {
  margin: 0;
  color: #092e28;
  font-family: "Manrope", "Inter", "Segoe UI Variable Display", sans-serif;
  font-size: clamp(1.04rem, 1.25vw, 1.5rem);
  line-height: 1.12;
  letter-spacing: -0.025em;
  word-spacing: 0.08em;
}

.feature-icon {
  display: inline-flex;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
}

.feature-icon {
  width: clamp(2.5rem, 3.15vw, 3.55rem);
  height: clamp(2.5rem, 3.15vw, 3.55rem);
  border: 0;
  border-radius: 0.85rem;
  color: var(--section-accent-strong);
  background: var(--section-accent-soft);
  box-shadow: none;
  font-size: clamp(1.1rem, 1.45vw, 1.5rem);
}

.feature-icon .product-icon {
  width: 84%;
  height: 84%;
  transform: scale(1.12);
}

.feature-illustration {
  display: block;
  flex: 1 1 auto;
  width: 100%;
  min-height: 4.2rem;
  max-height: clamp(8rem, 18.5dvh, 12.5rem);
  margin: clamp(0.45rem, 0.85vh, 0.7rem) 0 0;
  border-radius: 0.8rem;
  object-fit: cover;
  object-position: center top;
}

.feature-description {
  flex: 0 0 auto;
  min-height: 4.26em;
  margin: clamp(0.55rem, 1vh, 0.8rem) 0 0;
  color: #617089;
  font-size: clamp(0.82rem, 0.92vw, 1.08rem);
  line-height: 1.42;
}

.feature-actions {
  display: grid;
  flex: 0 0 auto;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: clamp(0.5rem, 0.8vw, 0.75rem);
  margin-top: auto;
  padding-top: clamp(0.55rem, 1.1vh, 0.85rem);
}

.feature-action {
  display: grid;
  grid-template-columns: auto max-content;
  align-items: center;
  justify-content: center;
  gap: clamp(0.38rem, 0.55vw, 0.55rem);
  min-height: clamp(4rem, 10dvh, 6.25rem);
  padding: 0.6rem clamp(0.45rem, 0.65vw, 0.7rem);
  box-sizing: border-box;
  border-radius: 0.85rem;
  text-decoration: none;
}

.feature-action > i {
  font-size: clamp(1.15rem, 1.45vw, 1.55rem);
}

.feature-action-product-icon {
  display: inline-flex;
  width: clamp(1.65rem, 1.9vw, 1.95rem);
  height: clamp(1.65rem, 1.9vw, 1.95rem);
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.feature-action-product-icon .product-icon {
  width: 100%;
  height: 100%;
  filter: invert(1) grayscale(1) brightness(2);
  mix-blend-mode: screen;
  transform: scale(1.48);
}

.feature-action-library-icon {
  display: inline-flex;
  width: clamp(2.1rem, 2.5vw, 2.65rem);
  height: clamp(2.1rem, 2.5vw, 2.65rem);
  align-items: center;
  justify-content: center;
}

.feature-action-library-icon .library-icon {
  width: 100%;
  height: 100%;
  transform: scale(1.12);
}

.feature-action-copy {
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 0.12rem;
}

.feature-action-copy strong {
  font-size: clamp(0.84rem, 0.98vw, 1.1rem);
  line-height: 1.15;
  white-space: nowrap;
}

.feature-action small {
  font-size: clamp(0.7rem, 0.78vw, 0.83rem);
  white-space: nowrap;
}

.feature-action.is-primary {
  color: #ffffff;
  background: linear-gradient(
    135deg,
    var(--section-accent),
    var(--section-accent-strong)
  );
  box-shadow: 0 8px 20px var(--section-accent-soft);
}

.feature-action.is-secondary {
  color: #183a2e;
  background: #ffffff;
  border: 1px solid var(--section-border);
}

.home-help-strip {
  display: flex;
  align-items: center;
  gap: 0.9rem;
  box-sizing: border-box;
  width: 94%;
  min-height: calc(clamp(2rem, 3vw, 3rem) + 1.3rem);
  margin: 0 auto;
  padding: 0.65rem clamp(0.85rem, 0.8vw, 1.5rem);
  border: 1px solid #e1e8e5;
  border-radius: 1rem;
  color: #0d3129;
  background: #ffffff;
  box-shadow: 0 7px 20px rgba(21, 44, 37, 0.05);
  text-decoration: none;
  transition: border-color 0.18s ease, box-shadow 0.18s ease;
}

.home-help-strip:hover {
  color: #0d3129;
  border-color: rgba(33, 105, 81, 0.34);
  box-shadow: 0 10px 24px rgba(21, 44, 37, 0.09);
}

.home-help-icon {
  display: inline-flex;
  width: clamp(1.9rem, 2.4vw, 2.35rem);
  height: clamp(1.9rem, 2.4vw, 2.35rem);
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  border-radius: 0.65rem;
  color: #49677f;
  background: linear-gradient(145deg, #eef3f7, #e1eaf0);
  font-size: clamp(1rem, 1.15vw, 1.2rem);
  transition: color 0.18s ease, background 0.18s ease;
}

.home-help-strip strong {
  font-size: clamp(0.9rem, 1vw, 1.05rem);
}

.home-help-chevron {
  margin-left: 0.15rem;
  color: #708078;
  font-size: 0.82rem;
}

@media (min-height: 901px) and (min-width: 901px) {
  .tools-grid {
    height: 98%;
  }

  .feature-illustration {
    min-height: clamp(8rem, 16dvh, 11rem);
  }
}

@media (max-height: 900px) and (min-width: 901px) {
  .home-shortcuts {
    width: clamp(17rem, 18vw, 18rem);
  }
}

@media (max-height: 760px) and (min-width: 901px) {
  .home {
    padding: 0.45rem 0;
  }

  .home-container {
    grid-template-rows: minmax(0, 1fr) auto auto;
    gap: 0.45rem;
  }

  .tools-grid {
    align-self: stretch;
    height: auto;
  }

  .home-hero-shell {
    padding: 0.85rem 1.5rem;
  }

  .home-hero-copy h1 {
    font-size: clamp(1.8rem, 2.35vw, 2.6rem);
  }

  .home-hero-copy p {
    margin-top: 0.45rem;
    font-size: clamp(0.82rem, 1.02vw, 1rem);
  }

  .feature-section {
    padding: 0.7rem 1rem;
  }

  .feature-icon {
    width: clamp(2.45rem, 2.9vw, 3rem);
    height: clamp(2.45rem, 2.9vw, 3rem);
  }

  .feature-illustration {
    min-height: 0;
    max-height: 19dvh;
    margin-top: 0.45rem;
  }

  .feature-description {
    min-height: 4.05em;
    margin-top: 0.4rem;
    font-size: clamp(0.78rem, 0.86vw, 0.96rem);
    line-height: 1.35;
  }

  .feature-actions {
    padding-top: 0.4rem;
  }

  .feature-action {
    min-height: clamp(3.25rem, 9dvh, 4rem);
  }

  .home-help-strip {
    gap: 0.7rem;
    min-height: 3.2rem;
    padding: 0.35rem 0.5rem;
  }

  .home-help-icon {
    width: 2.15rem;
    height: 2.15rem;
  }
}

@media (max-width: 900px) {
  .container.home-route {
    height: auto;
    min-height: 100dvh;
    overflow-y: auto;
  }

  .home {
    overflow: visible;
  }

  .home-container {
    display: flex;
    flex-direction: column;
    width: min(calc(100% - 1.5rem), 42rem);
    height: auto;
  }

  .tools-grid {
    align-self: stretch;
    height: auto;
  }

  .home-hero-shell {
    flex: 0 0 auto;
    flex-direction: column;
    align-items: stretch;
    width: 100%;
  }

  .home-hero-visual {
    inset: 0;
    width: 100%;
    height: 100%;
    opacity: 0.3;
    -webkit-mask-image: none;
    mask-image: none;
  }

  .home-hero-art {
    width: 100%;
    max-width: 100%;
    height: 100%;
    object-fit: cover;
    transform: none;
  }

  .home-hero-copy {
    padding-right: 1rem;
  }

  .home-shortcuts {
    flex-basis: auto;
    width: min(100%, 25rem);
  }

  .tools-grid {
    flex-basis: auto;
    grid-template-columns: 1fr;
    width: 100%;
  }

  .home-help-strip {
    width: 100%;
  }

  .feature-section {
    min-height: 27rem;
  }

  .feature-illustration {
    max-height: 11rem;
  }
}

/* Nel menu ospite il testo delle azioni parte sempre dalla stessa colonna. */
.dropdown-menu-account.account-menu-guest .guest-account-action > span {
  justify-self: start;
  width: 100%;
  text-align: left;
}
</style>
